<template>
  <div class="ts-app-shell_fh">
    <div style="background-color: #f9f9f9;">
      <el-form>
        <el-dialog
          :title="controlTitle"
          :visible.sync="this.showControl"
          :show-close="false"
          :append-to-body="true"
          width="600px"
          class="ts-modal"
        >
          <button
            type="button"
            aria-label="Close"
            class="el-dialog__headerbtn"
            @click="closeAddControl(null)"
          >
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>
          <p>{{ controlDesc }}</p>
          <template v-for="i in dynamicProp.length">
            <div :key="i">
              <div
                v-bind:style="
                  _element[i - 1].display
                    ? { display: 'block' }
                    : { display: 'none' }
                "
              >
                <el-col
                  :xl="8"
                  :lg="8"
                  :md="8"
                  :sm="8"
                  :xs="8"
                  class="mobile-label"
                >
                  <span :data-label="_element[i - 1].Title">{{
                    _element[i - 1].Title
                  }}</span>
                </el-col>
                <el-col
                  :xl="16"
                  :lg="16"
                  :md="16"
                  :sm="16"
                  :xs="16"
                  class="mobile-element"
                >
                  <el-input
                    v-if="_element[i - 1].type == 'string'"
                    type="text"
                    v-model="dynamicObj[dynamicProp[i - 1]]"
                    style="width: 300px;"
                    class="string-element"
                  />
                  <el-input
                    v-else-if="_element[i - 1].type == 'number'"
                    type="number"
                    v-model="dynamicObj[dynamicProp[i - 1]]"
                    style="width: 300px;"
                    class="number-element"
                  />
                  <el-date-picker
                    v-else-if="
                      _element[i - 1].type == 'date' &&
                        (_element[i - 1].Title == 'Expiration Date' ||
                          _element[i - 1].Title == 'End Date')
                    "
                    v-model="dynamicObj[dynamicProp[i - 1]]"
                    type="date"
                    placeholder="Pick a date"
                    :disabled="
                      dynamicObj['NoExpiration'] ||
                        dynamicObj['WorkedToPresent']
                    "
                    class="date-element"
                  ></el-date-picker>
                  <el-date-picker
                    v-else-if="_element[i - 1].type == 'date'"
                    v-model="dynamicObj[dynamicProp[i - 1]]"
                    type="date"
                    placeholder="Pick a date"
                    class="date-element"
                  ></el-date-picker>
                  <el-switch
                    v-else-if="_element[i - 1].type == 'boolean'"
                    v-model="dynamicObj[dynamicProp[i - 1]]"
                    active-color="#13ce66"
                    class="boolean-element"
                  >
                    &nbsp;
                  </el-switch>
                  <el-select
                    v-else-if="_element[i - 1].type == 'yearsofexp'"
                    placeholder="Years of experience"
                    style="width: 300px; height:"
                    class="year-element"
                    v-model="dynamicObj[dynamicProp[i - 1]]"
                  >
                    <el-option value="less than a year"
                      >Less than one year</el-option
                    >
                    <el-option value="1-2 years">1-2 years</el-option>
                    <el-option value="3-5 years">3-5 years</el-option>
                    <el-option value="5-10 years">5-10 years</el-option>
                    <el-option value="10+ years">10+ years</el-option>
                  </el-select>
                  <el-select
                    v-else-if="_element[i - 1].type == 'grade'"
                    placeholder="Select Grade"
                    style="width: 300px;"
                    class="grade-element"
                    v-model="dynamicObj[dynamicProp[i - 1]]"
                  >
                    <el-option value="A*">A*</el-option>
                    <el-option value="A">A</el-option>
                    <el-option value="B">B</el-option>
                    <el-option value="C*">C*</el-option>
                    <el-option value="C">C</el-option>
                    <el-option value="D">D</el-option>
                    <el-option value="E">E</el-option>
                  </el-select>
                </el-col>
              </div>
            </div>
          </template>
          <div class="ts-modal_actions" style="padding-top:30px;">
            <button
              class="ts-btn ts-btn-white ts-btn-small"
              @click="closeAddControl(null)"
            >
              Cancel
            </button>
            <button class="ts-btn ts-btn-small" @click="addField(dynamicObj)">
              Add
            </button>
          </div>
        </el-dialog>

        <el-dialog
          title="Secondary Level"
          :visible.sync="this.showSecondaryModal"
          :show-close="false"
          :append-to-body="true"
          width="600px"
          class="ts-modal"
        >
          <button
            type="button"
            aria-label="Close"
            class="el-dialog__headerbtn"
            @click="closeSecondaryModal(null)"
          >
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>
          <p>Please select additional second level education to your resume</p>
          <el-switch
            v-model="
              setting.profileConfiguration.personalInformation.education
                .secondaryLevelValue.highSchoolDiploma
            "
            active-color="#13ce66"
            @change="
              setting.profileConfiguration.personalInformation.education.secondaryLevelValue.highSchoolDiplomaValue = setting
                .profileConfiguration.personalInformation.education
                .secondaryLevelValue.highSchoolDiploma
                ? 'High School Diploma'
                : 'n/a'
            "
          ></el-switch>
          <span>&nbsp; High School Diploma</span><br />
          <el-switch
            v-model="
              setting.profileConfiguration.personalInformation.education
                .secondaryLevelValue.ged
            "
            active-color="#13ce66"
            @change="
              setting.profileConfiguration.personalInformation.education.secondaryLevelValue.gedValue = setting
                .profileConfiguration.personalInformation.education
                .secondaryLevelValue.ged
                ? 'General Equivalent Diploma'
                : 'n/a'
            "
          ></el-switch>
          <span>&nbsp; GED (General Equivalent Diploma)</span><br />
          <el-switch
            v-model="
              setting.profileConfiguration.personalInformation.education
                .secondaryLevelValue.leavingCert
            "
            active-color="#13ce66"
            @change="
              setting.profileConfiguration.personalInformation.education.secondaryLevelValue.leavingCertValue = setting
                .profileConfiguration.personalInformation.education
                .secondaryLevelValue.leavingCert
                ? 'Leaving Cert'
                : 'n/a'
            "
          >
          </el-switch>
          <span>&nbsp; Leaving Cert</span><br />
          <div class="ts-modal_actions" style="padding-top:30px;">
            <button
              class="ts-btn ts-btn-white ts-btn-small"
              @click="closeSecondaryModal(null)"
            >
              Cancel
            </button>
            <button
              class="ts-btn ts-btn-small"
              @click="addSecondaryEducation()"
            >
              Add
            </button>
          </div>
        </el-dialog>

        <el-row style="padding:10px;" :class="create ? 'create_div' : ''">
          <el-col>
            <el-col
              v-if="create"
              class="narrow"
              :xl="24"
              :lg="24"
              :md="24"
              :sm="24"
              :xs="24"
              style="padding-bottom:10px;"
            >
              <h6>Create Resume Section</h6>
            </el-col>

            <el-col
              v-if="create"
              class="setting-info"
              :xl="9"
              :lg="9"
              :md="9"
              :sm="9"
              :xs="24"
            >
              <span class="setting-title">Resume Name</span> <br />
              <el-form-item :error="settingNameError" :required="true">
                <el-input
                  placeholder="Resume name"
                  v-model="setting.profileName"
                  style="width: 90%;"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-col>

          <el-col :xl="9" :lg="9" :md="9" :sm="9" :xs="24">
            <span class="setting-title">Personal Information</span> <br />
            <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
              <el-checkbox
                v-model="
                  setting.profileConfiguration.personalInformation.profilePhoto
                "
                :disabled="setting.profileName == 'Default' ? true : false"
                >Profile Photo</el-checkbox
              >
              <br />
              <el-checkbox
                v-model="
                  setting.profileConfiguration.personalInformation.jobTitle
                "
                :disabled="setting.profileName == 'Default' ? true : false"
                >Job Title</el-checkbox
              >
              <i
                v-show="
                  setting.profileConfiguration.personalInformation.jobTitle
                "
                class="el-icon-circle-plus add_oleveldetails"
                style="color: #13ce66; font-size: 20px; float: right; margin-right:10%; top:10px; padding:2px;"
                @click="
                  addJobTitle(
                    setting.profileConfiguration.personalInformation
                      .jobTitleValue.titles
                  )
                "
              ></i
              ><br />
              <div
                v-if="setting.profileConfiguration.personalInformation.jobTitle"
              >
                <div
                  v-if="
                    setting.profileConfiguration.personalInformation
                      .jobTitleValue != null &&
                      setting.profileConfiguration.personalInformation
                        .jobTitleValue.titles.length > 0
                  "
                >
                  <div
                    v-for="(item, index) in setting.profileConfiguration
                      .personalInformation.jobTitleValue.titles"
                    :key="index"
                  >
                    <el-input
                      class="dot_textbox"
                      v-model="
                        setting.profileConfiguration.personalInformation
                          .jobTitleValue.titles[index]
                      "
                      style="width: 90%; margin-left: 10px;"
                    /><i
                      class="el-icon-remove delete_aleveldetails"
                      style="color: #dc3c3c; font-size: 20px"
                      @click="
                        deleteField(
                          index,
                          setting.profileConfiguration.personalInformation
                            .jobTitleValue.titles
                        )
                      "
                    ></i>
                  </div>
                </div>
                <div v-else>
                  <span style="margin-left: 10px;">N/A</span>
                </div>
              </div>
              <br />

              <el-checkbox
                v-model="
                  setting.profileConfiguration.personalInformation.seekingRole
                "
                :disabled="setting.profileName == 'Default' ? true : false"
                >Statement/Seeking Role</el-checkbox
              >
              <br />
              <el-input
                type="text"
                class="dot_textbox nullable"
                v-show="
                  setting.profileConfiguration.personalInformation.seekingRole
                "
                v-model="
                  setting.profileConfiguration.personalInformation
                    .seekingRoleValue
                "
                style="width: 90%"
              /><br
                v-show="
                  setting.profileConfiguration.personalInformation.seekingRole
                "
              />

              <el-checkbox
                v-model="setting.profileConfiguration.personalInformation.email"
                :disabled="setting.profileName == 'Default' ? true : false"
                >Email</el-checkbox
              >
              <br />
              <el-input
                type="text"
                class="dot_textbox"
                v-show="setting.profileConfiguration.personalInformation.email"
                v-model="
                  setting.profileConfiguration.personalInformation.emailValue
                "
                style="width: 90%;"
              /><br
                v-show="setting.profileConfiguration.personalInformation.email"
              />
              <el-checkbox
                v-model="
                  setting.profileConfiguration.personalInformation.address
                "
                :disabled="setting.profileName == 'Default' ? true : false"
                >ZipCode</el-checkbox
              >
              <br />
              <el-input
                type="text"
                class="dot_textbox"
                v-show="
                  setting.profileConfiguration.personalInformation.address
                "
                v-model="
                  setting.profileConfiguration.personalInformation.addressValue
                "
                style="width: 90%;"
              /><br
                v-show="
                  setting.profileConfiguration.personalInformation.address
                "
              />
              <el-checkbox
                v-model="setting.profileConfiguration.personalInformation.phone"
                :disabled="setting.profileName == 'Default' ? true : false"
                >Phone</el-checkbox
              >
              <br />
              <el-input
                type="text"
                class="dot_textbox"
                v-show="setting.profileConfiguration.personalInformation.phone"
                v-model="
                  setting.profileConfiguration.personalInformation.phoneValue
                "
                style="width: 90%;"
              />
              <el-checkbox
                v-model="
                  setting.profileConfiguration.personalInformation
                    .certifications
                "
                :disabled="setting.profileName == 'Default' ? true : false"
                >Certifications</el-checkbox
              >
              <i
                v-show="
                  setting.profileConfiguration.personalInformation
                    .certifications
                "
                class="el-icon-circle-plus add_oleveldetails"
                style="color: #13ce66; font-size: 20px; float: right; margin-right:10%; top:10px; padding:2px;"
                @click="
                  addCertification(
                    setting.profileConfiguration.personalInformation
                      .certificationsValue.userCertifications
                  )
                "
              ></i>
              <br />
              <div
                v-show="
                  setting.profileConfiguration.personalInformation
                    .certifications
                "
                v-for="(item, index) in this.setting.profileConfiguration
                  .personalInformation.certificationsValue.userCertifications"
                :key="'userCertifications' + index"
              >
                <input type="hidden" :value="item.description" />
                <el-input
                  class="dot_textbox"
                  v-model="item.codeDetailDesc"
                  style="width: 90%;"
                /><i
                  class="el-icon-remove delete_aleveldetails"
                  style="color: #dc3c3c; font-size: 20px"
                  @click="
                    deleteField(
                      index,
                      setting.profileConfiguration.personalInformation
                        .certificationsValue.userCertifications,
                      false,
                      'Certificate'
                    )
                  "
                ></i>
              </div>
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
                :disabled="setting.profileName == 'Default' ? true : false"
                >Education</el-checkbox
              >
              <br />
              {{ educationHaveTrue }}
              <el-checkbox
                v-model="
                  setting.profileConfiguration.personalInformation.education
                    .secondaryLevel
                "
                class="checkbox-child"
                :disabled="setting.profileName == 'Default' ? true : false"
                >Secondary Level</el-checkbox
              >
              <i
                class="el-icon-circle-plus add_oleveldetails"
                style="color: #13ce66; font-size: 20px; float: right; margin-right:10%; top:10px; padding:2px;"
                @click="addSecondaryModal()"
              ></i
              ><br />
              <div
                v-show="
                  setting.profileConfiguration.personalInformation.education
                    .secondaryLevel
                "
              >
                <el-input
                  class="dot_textbox"
                  v-if="
                    setting.profileConfiguration.personalInformation.education
                      .secondaryLevelValue.highSchoolDiplomaValue != 'n/a'
                  "
                  v-model="
                    setting.profileConfiguration.personalInformation.education
                      .secondaryLevelValue.highSchoolDiplomaValue
                  "
                  style="width: 90%; margin-left: 10px;"
                /><br
                  v-if="
                    setting.profileConfiguration.personalInformation.education
                      .secondaryLevelValue.highSchoolDiplomaValue != 'n/a'
                  "
                />

                <el-checkbox
                  v-if="
                    setting.profileConfiguration.personalInformation.education
                      .secondaryLevelValue.highSchoolDiploma
                  "
                  v-model="
                    setting.profileConfiguration.personalInformation.education
                      .secondaryLevelValue.highSchoolDiplomaAttending
                  "
                  @change="
                    openGradDateModal(
                      'HSD',
                      setting.profileConfiguration.personalInformation.education
                        .secondaryLevelValue.highSchoolDiplomaGraduationDate,
                      setting.profileConfiguration.personalInformation.education
                        .secondaryLevelValue.highSchoolDiplomaAttending
                    )
                  "
                  style="width: 90%; margin-left: 30px;"
                >
                  <span
                    v-if="
                      setting.profileConfiguration.personalInformation.education
                        .secondaryLevelValue.highSchoolDiplomaAttending
                    "
                  >
                    Currently attending, estimated graduation date is
                    {{
                      setting.profileConfiguration.personalInformation.education
                        .secondaryLevelValue.highSchoolDiplomaGraduationDate
                        | moment("MMMM DD, YYYY")
                    }}
                  </span>
                  <span v-else>
                    Please mark this checkbox if you are currently attending
                    this program
                  </span>
                  <el-input
                    type="hidden"
                    v-model="
                      setting.profileConfiguration.personalInformation.education
                        .secondaryLevelValue.highSchoolDiplomaGraduationDate
                    "
                  />
                </el-checkbox>
                <br />

                <el-input
                  class="dot_textbox"
                  v-if="
                    setting.profileConfiguration.personalInformation.education
                      .secondaryLevelValue.gedValue != 'n/a'
                  "
                  v-model="
                    setting.profileConfiguration.personalInformation.education
                      .secondaryLevelValue.gedValue
                  "
                  style="width: 90%; margin-left: 10px;"
                /><br
                  v-if="
                    setting.profileConfiguration.personalInformation.education
                      .secondaryLevelValue.gedValue != 'n/a'
                  "
                />
                <el-checkbox
                  v-if="
                    setting.profileConfiguration.personalInformation.education
                      .secondaryLevelValue.ged
                  "
                  v-model="
                    setting.profileConfiguration.personalInformation.education
                      .secondaryLevelValue.gedAttending
                  "
                  @change="
                    openGradDateModal(
                      'GED',
                      setting.profileConfiguration.personalInformation.education
                        .secondaryLevelValue.gedGraduationDate,
                      setting.profileConfiguration.personalInformation.education
                        .secondaryLevelValue.gedAttending
                    )
                  "
                  style="width: 90%; margin-left: 30px;"
                >
                  <span
                    v-if="
                      setting.profileConfiguration.personalInformation.education
                        .secondaryLevelValue.gedAttending
                    "
                  >
                    Currently attending, estimated graduation date is
                    {{
                      setting.profileConfiguration.personalInformation.education
                        .secondaryLevelValue.gedGraduationDate
                        | moment("MMMM DD, YYYY")
                    }}
                  </span>
                  <span v-else>
                    Please mark this checkbox if you are currently attending
                    this program
                  </span>
                  <el-input
                    type="hidden"
                    v-model="
                      setting.profileConfiguration.personalInformation.education
                        .secondaryLevelValue.gedGraduationDate
                    "
                  />
                </el-checkbox>
                <br />

                <el-input
                  class="dot_textbox"
                  v-if="
                    setting.profileConfiguration.personalInformation.education
                      .secondaryLevelValue.leavingCertValue != 'n/a'
                  "
                  v-model="
                    setting.profileConfiguration.personalInformation.education
                      .secondaryLevelValue.leavingCertValue
                  "
                  style="width: 90%;"
                /><br
                  v-if="
                    setting.profileConfiguration.personalInformation.education
                      .secondaryLevelValue.leavingCertValue != 'n/a'
                  "
                />
                <el-tooltip placement="top">
                  <span style="font-size: 12px">
                    O-Levels / GCSEs <i class="fas fa-info-circle"></i>
                  </span>
                  <div slot="content" style="text-align: center">
                    Only Applicable in UK country.
                  </div>
                </el-tooltip>
                <i
                  v-show="
                    setting.profileConfiguration.personalInformation.education
                      .secondaryLevel
                  "
                  class="el-icon-circle-plus add_oleveldetails"
                  style="color: #13ce66; font-size: 20px; float: right; margin-right:10%; top:10px; padding:2px;"
                  @click="
                    addOLevel(
                      setting.profileConfiguration.personalInformation.education
                        .secondaryLevelValue.oLevelDetailsValue
                    )
                  "
                ></i>
                <div
                  v-if="
                    setting.profileConfiguration.personalInformation.education
                      .secondaryLevelValue.oLevelDetailsValue != null &&
                      setting.profileConfiguration.personalInformation.education
                        .secondaryLevelValue.oLevelDetailsValue.length != 0
                  "
                >
                  <div
                    v-for="(item, index) in setting.profileConfiguration
                      .personalInformation.education.secondaryLevelValue
                      .oLevelDetailsValue"
                    :key="'oLevelDetailsValue' + index"
                  >
                    <el-input
                      class="dot_textbox"
                      v-model="item.subject"
                      style="width: 90%;"
                    /><i
                      class="el-icon-remove delete_aleveldetails"
                      style="color: #dc3c3c; font-size: 20px"
                      @click="
                        deleteField(
                          index,
                          setting.profileConfiguration.personalInformation
                            .education.secondaryLevelValue.oLevelDetailsValue,
                          null,
                          'O-Level'
                        )
                      "
                    ></i>
                  </div>
                </div>
                <div v-else>
                  <span style="margin-left: 10px;">N/A</span>
                </div>
                <el-tooltip placement="top">
                  <span style="font-size: 12px">
                    A-Levels <i class="fas fa-info-circle"></i> OR Equivalent
                  </span>
                  <div slot="content" style="text-align: center">
                    Only Applicable in UK country. <br />If you have a
                    qualification equivalent to A Levels, <br />please input
                    your grade below in the ‘grade’ dropdown and <br />input the
                    subject and course title in the ‘Subject’ text field
                  </div>
                </el-tooltip>
                <i
                  v-show="
                    setting.profileConfiguration.personalInformation.education
                      .secondaryLevel
                  "
                  class="el-icon-circle-plus add_oleveldetails"
                  style="color: #13ce66; font-size: 20px; float: right; margin-right:10%; top:10px; padding:2px;"
                  @click="
                    addALevel(
                      setting.profileConfiguration.personalInformation.education
                        .secondaryLevelValue.aLevelDetailsValue
                    )
                  "
                ></i>
                <div
                  v-if="
                    setting.profileConfiguration.personalInformation.education
                      .secondaryLevelValue.aLevelDetailsValue != null &&
                      setting.profileConfiguration.personalInformation.education
                        .secondaryLevelValue.aLevelDetailsValue.length != 0
                  "
                >
                  <div
                    v-for="(item, index) in setting.profileConfiguration
                      .personalInformation.education.secondaryLevelValue
                      .aLevelDetailsValue"
                    :key="'aLevelDetailsValue' + index"
                  >
                    <el-input
                      class="dot_textbox"
                      v-model="item.subject"
                      style="width: 90%;"
                    /><i
                      class="el-icon-remove delete_aleveldetails"
                      style="color: #dc3c3c; font-size: 20px"
                      @click="
                        deleteField(
                          index,
                          setting.profileConfiguration.personalInformation
                            .education.secondaryLevelValue.aLevelDetailsValue,
                          null,
                          'A-Level'
                        )
                      "
                    ></i>
                  </div>
                </div>
                <div v-else>
                  <span style="margin-left: 10px;">N/A</span>
                </div>
              </div>
              <el-checkbox
                v-model="
                  setting.profileConfiguration.personalInformation.education
                    .thirdLevel
                "
                class="checkbox-child"
                :disabled="setting.profileName == 'Default' ? true : false"
                >Third Level</el-checkbox
              >
              <br />
              <div
                v-if="
                  setting.profileConfiguration.personalInformation.education
                    .thirdLevel
                "
              >
                <span style="font-size: 12px">Associate Degree</span>
                <i
                  v-show="
                    setting.profileConfiguration.personalInformation.education
                      .thirdLevel
                  "
                  class="el-icon-circle-plus add_oleveldetails"
                  style="color: #13ce66; font-size: 20px; float: right; margin-right:10%; top:10px; padding:2px;"
                  @click="
                    addAssociateDegree(
                      setting.profileConfiguration.personalInformation.education
                        .thirdLevelValue.associateDegreeDetails
                    )
                  "
                ></i>
                <div
                  id="associatedegreedetails_template"
                  v-if="
                    setting.profileConfiguration.personalInformation.education
                      .thirdLevelValue.associateDegreeDetails != null &&
                      setting.profileConfiguration.personalInformation.education
                        .thirdLevelValue.associateDegreeDetails.length > 0
                  "
                >
                  <div
                    v-for="(item, index) in setting.profileConfiguration
                      .personalInformation.education.thirdLevelValue
                      .associateDegreeDetails"
                    :key="'associateDegreeDetails' + index"
                  >
                    <el-input
                      class="dot_textbox"
                      v-model="item.courseTitle"
                      style="width: 90%;"
                    /><i
                      class="el-icon-remove delete_aleveldetails"
                      style="color: #dc3c3c; font-size: 20px"
                      @click="
                        deleteField(
                          index,
                          setting.profileConfiguration.personalInformation
                            .education.thirdLevelValue.associateDegreeDetails,
                          null,
                          'Associate Degree'
                        )
                      "
                    ></i>

                    <el-checkbox
                      class="associate-degree-attending"
                      style="width: 90%; margin-left: 30px;"
                      v-model="item.currentlyAttending"
                      @change="openAssocGradDateModal(index)"
                    >
                      <span v-if="item.currentlyAttending">
                        Currently attending, estimated graduation date is
                        {{ item.graduationDate | moment("MMMM DD, YYYY") }}
                      </span>
                      <span v-else>
                        Please mark this checkbox if you are currently attending
                        this program
                      </span>
                    </el-checkbox>
                    <br />
                    <el-input
                      class="associate-degree-date"
                      type="hidden"
                      v-model="item.graduationDate"
                    />
                  </div>
                </div>
                <div v-else>
                  <span style="margin-left: 10px; font-size: 12px">N/A</span>
                </div>
                <span style="font-size: 12px">Bachelors Degree</span>
                <i
                  v-show="
                    setting.profileConfiguration.personalInformation.education
                      .thirdLevel
                  "
                  class="el-icon-circle-plus add_oleveldetails"
                  style="color: #13ce66; font-size: 20px; float: right; margin-right:10%; top:10px; padding:2px;"
                  @click="
                    addBachelorsDegree(
                      setting.profileConfiguration.personalInformation.education
                        .thirdLevelValue.bachelorsDegreeDetails
                    )
                  "
                ></i>
                <div
                  id="bachelorsdegreedetails_template"
                  v-if="
                    setting.profileConfiguration.personalInformation.education
                      .thirdLevelValue.bachelorsDegreeDetails != null &&
                      setting.profileConfiguration.personalInformation.education
                        .thirdLevelValue.bachelorsDegreeDetails.length > 0
                  "
                >
                  <div
                    v-for="(item, index) in setting.profileConfiguration
                      .personalInformation.education.thirdLevelValue
                      .bachelorsDegreeDetails"
                    :key="'bachelorsDegreeDetails' + index"
                  >
                    <el-input
                      class="dot_textbox"
                      v-model="item.courseTitle"
                      style="width: 90%;"
                    /><i
                      class="el-icon-remove delete_aleveldetails"
                      style="color: #dc3c3c; font-size: 20px"
                      @click="
                        deleteField(
                          index,
                          setting.profileConfiguration.personalInformation
                            .education.thirdLevelValue.bachelorsDegreeDetails,
                          null,
                          'Bachelors Degree'
                        )
                      "
                    ></i>

                    <el-checkbox
                      class="bachelors-degree-attending"
                      style="width: 90%; margin-left: 30px;"
                      v-model="item.currentlyAttending"
                      @change="openAssocGradDateModal(index)"
                    >
                      <span v-if="item.currentlyAttending">
                        Currently attending, estimated graduation date is
                        {{ item.graduationDate | moment("MMMM DD, YYYY") }}
                      </span>
                      <span v-else>
                        Please mark this checkbox if you are currently attending
                        this program
                      </span>
                    </el-checkbox>
                    <br />
                    <el-input
                      class="bachelors-degree-date"
                      type="hidden"
                      v-model="item.graduationDate"
                    />
                  </div>
                </div>
                <div v-else>
                  <span style="margin-left: 10px; font-size: 12px">N/A</span>
                </div>
              </div>
              <el-checkbox
                v-model="
                  setting.profileConfiguration.personalInformation.education
                    .fourthLevel
                "
                class="checkbox-child"
                :disabled="setting.profileName == 'Default' ? true : false"
                >Fourth Level</el-checkbox
              >
              <br />
              <div
                v-if="
                  setting.profileConfiguration.personalInformation.education
                    .fourthLevel
                "
              >
                <span style="font-size: 12px">Masters Degree</span>
                <i
                  v-show="
                    setting.profileConfiguration.personalInformation.education
                      .fourthLevel
                  "
                  class="el-icon-circle-plus add_oleveldetails"
                  style="color: #13ce66; font-size: 20px; float: right; margin-right:10%; top:10px; padding:2px;"
                  @click="
                    addMastersDegree(
                      setting.profileConfiguration.personalInformation.education
                        .fourthLevelValue.mastersDegreeDetails
                    )
                  "
                ></i>
                <div
                  id="mastersdegreedetails_template"
                  v-if="
                    setting.profileConfiguration.personalInformation.education
                      .fourthLevelValue.mastersDegreeDetails != null &&
                      setting.profileConfiguration.personalInformation.education
                        .fourthLevelValue.mastersDegreeDetails.length > 0
                  "
                >
                  <div
                    v-for="(item, index) in setting.profileConfiguration
                      .personalInformation.education.fourthLevelValue
                      .mastersDegreeDetails"
                    :key="'mastersDegreeDetails' + index"
                  >
                    <el-input
                      class="dot_textbox"
                      v-model="item.courseTitle"
                      style="width: 90%;"
                    /><i
                      class="el-icon-remove delete_aleveldetails"
                      style="color: #dc3c3c; font-size: 20px"
                      @click="
                        deleteField(
                          index,
                          setting.profileConfiguration.personalInformation
                            .education.fourthLevelValue.mastersDegreeDetails,
                          null,
                          'Masters Degree'
                        )
                      "
                    ></i>

                    <el-checkbox
                      class="masters-degree-attending"
                      style="width: 90%; margin-left: 30px;"
                      v-model="item.currentlyAttending"
                      @change="openAssocGradDateModal(index)"
                    >
                      <span v-if="item.currentlyAttending">
                        Currently attending, estimated graduation date is
                        {{ item.graduationDate | moment("MMMM DD, YYYY") }}
                      </span>
                      <span v-else>
                        Please mark this checkbox if you are currently attending
                        this program
                      </span>
                    </el-checkbox>
                    <br />
                    <el-input
                      class="masters-degree-date"
                      type="hidden"
                      v-model="item.graduationDate"
                    />
                  </div>
                </div>
                <div v-else>
                  <span style="margin-left: 10px; font-size: 12px">N/A</span>
                </div>
                <span style="font-size: 12px">Doctoral Degree</span>
                <i
                  v-show="
                    setting.profileConfiguration.personalInformation.education
                      .fourthLevel
                  "
                  class="el-icon-circle-plus add_oleveldetails"
                  style="color: #13ce66; font-size: 20px; float: right; margin-right:10%; top:10px; padding:2px;"
                  @click="
                    addDoctoralDegree(
                      setting.profileConfiguration.personalInformation.education
                        .fourthLevelValue.doctoralDegreeDetails
                    )
                  "
                ></i>
                <div
                  id="doctoraldegreedetails_template"
                  v-if="
                    setting.profileConfiguration.personalInformation.education
                      .fourthLevelValue.doctoralDegreeDetails != null &&
                      setting.profileConfiguration.personalInformation.education
                        .fourthLevelValue.doctoralDegreeDetails.length > 0
                  "
                >
                  <div
                    v-for="(item, index) in setting.profileConfiguration
                      .personalInformation.education.fourthLevelValue
                      .doctoralDegreeDetails"
                    :key="'doctoralDegreeDetails' + index"
                  >
                    <el-input
                      class="dot_textbox"
                      v-model="item.courseTitle"
                      style="width: 90%;"
                    /><i
                      class="el-icon-remove delete_aleveldetails"
                      style="color: #dc3c3c; font-size: 20px"
                      @click="
                        deleteField(
                          index,
                          setting.profileConfiguration.personalInformation
                            .education.fourthLevelValue.doctoralDegreeDetails,
                          null,
                          'Doctoral Degree'
                        )
                      "
                    ></i>

                    <el-checkbox
                      class="doctoral-degree-attending"
                      style="width: 90%; margin-left: 30px;"
                      v-model="item.currentlyAttending"
                      @change="openAssocGradDateModal(index)"
                    >
                      <span v-if="item.currentlyAttending">
                        Currently attending, estimated graduation date is
                        {{ item.graduationDate | moment("MMMM DD, YYYY") }}
                      </span>
                      <span v-else>
                        Please mark this checkbox if you are currently attending
                        this program
                      </span>
                    </el-checkbox>
                    <br />
                    <el-input
                      class="doctoral-degree-date"
                      type="hidden"
                      v-model="item.graduationDate"
                    />
                  </div>
                </div>
                <div v-else>
                  <span style="margin-left: 10px; font-size: 12px">N/A</span>
                </div>
              </div>
            </el-col>
          </el-col>
          <el-col :xl="1" :lg="1" :md="1" :sm="1" :xs="1">
            &nbsp;
          </el-col>
          <el-col :xl="10" :lg="10" :md="10" :sm="10" :xs="24">
            <span class="setting-title">Core Strength Information</span> <br />
            <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
              <el-checkbox
                v-model="
                  setting.profileConfiguration.coreStrengthInformation
                    .workHistory
                "
                :disabled="setting.profileName == 'Default' ? true : false"
                >Work History</el-checkbox
              >
              <i
                v-show="
                  setting.profileConfiguration.coreStrengthInformation
                    .workHistory
                "
                class="el-icon-circle-plus add_oleveldetails"
                style="color: #13ce66; font-size: 20px; float: right; margin-right:10%; top:10px; padding:2px;"
                @click="
                  addWorkHistory(
                    setting.profileConfiguration.coreStrengthInformation
                      .workHistoryValue.userWorkHistory
                  )
                "
              ></i>
              <br />
              <div
                v-show="
                  setting.profileConfiguration.coreStrengthInformation
                    .workHistory
                "
                v-for="(item, index) in this.setting.profileConfiguration
                  .coreStrengthInformation.workHistoryValue.userWorkHistory"
                :key="'userWorkHistory' + index"
              >
                <el-input
                  class="dot_textbox"
                  v-model="item.jobTitle"
                  style="width: 90%;"
                /><i
                  class="el-icon-remove delete_aleveldetails"
                  style="color: #dc3c3c; font-size: 20px"
                  @click="
                    deleteField(
                      index,
                      setting.profileConfiguration.coreStrengthInformation
                        .workHistoryValue.userWorkHistory
                    )
                  "
                ></i>
              </div>
              <el-checkbox
                v-model="
                  setting.profileConfiguration.coreStrengthInformation
                    .taskDuties
                "
                :disabled="setting.profileName == 'Default' ? true : false"
                >Task/Duties</el-checkbox
              >
              <i
                v-show="
                  setting.profileConfiguration.coreStrengthInformation
                    .taskDuties
                "
                class="el-icon-circle-plus add_oleveldetails"
                style="color: #13ce66; font-size: 20px; float: right; margin-right:10%; top:10px; padding:2px;"
                @click="
                  addTask(
                    setting.profileConfiguration.coreStrengthInformation
                      .taskDutiesValue.jobDescriptionTasks
                  )
                "
              ></i>
              <br />
              <div
                v-show="
                  setting.profileConfiguration.coreStrengthInformation
                    .taskDuties
                "
                v-for="(item, index) in this.setting.profileConfiguration
                  .coreStrengthInformation.taskDutiesValue.jobDescriptionTasks"
                :key="'jobDescriptionTasks' + index"
              >
                <div
                  v-if="
                    setting.profileConfiguration.coreStrengthInformation.taskDutiesValue.jobDescriptionTasks[
                      index
                    ].indexOf('`') > -1
                  "
                >
                  <el-input
                    class="dot_textbox"
                    v-model="formattedTask[index]"
                    style="width: 90%;"
                  /><i
                    class="el-icon-remove delete_aleveldetails"
                    style="color: #dc3c3c; font-size: 20px"
                    @click="
                      deleteField(
                        index,
                        setting.profileConfiguration.coreStrengthInformation
                          .taskDutiesValue.jobDescriptionTasks,
                        true
                      )
                    "
                  ></i>
                </div>
                <div v-else>
                  <el-input
                    class="dot_textbox"
                    v-model="
                      setting.profileConfiguration.coreStrengthInformation
                        .taskDutiesValue.jobDescriptionTasks[index]
                    "
                    style="width: 90%;"
                  />
                  <i
                    class="el-icon-remove delete_aleveldetails"
                    style="color: #dc3c3c; font-size: 20px"
                    @click="
                      deleteField(
                        index,
                        setting.profileConfiguration.coreStrengthInformation
                          .taskDutiesValue.jobDescriptionTasks,
                        true
                      )
                    "
                  ></i>
                </div>
              </div>
              <el-checkbox
                v-model="
                  setting.profileConfiguration.coreStrengthInformation
                    .activities
                "
                :disabled="setting.profileName == 'Default' ? true : false"
                >Activities</el-checkbox
              >
              <i
                v-show="
                  setting.profileConfiguration.coreStrengthInformation
                    .activities
                "
                class="el-icon-circle-plus add_oleveldetails"
                style="color: #13ce66; font-size: 20px; float: right; margin-right:10%; top:10px; padding:2px;"
                @click="
                  addActivities(
                    setting.profileConfiguration.coreStrengthInformation
                      .activitiesValue.workingPracticeActivities
                  )
                "
              ></i>
              <br />
              <div
                v-show="
                  setting.profileConfiguration.coreStrengthInformation
                    .activities
                "
                v-for="(item, index) in this.setting.profileConfiguration
                  .coreStrengthInformation.activitiesValue
                  .workingPracticeActivities"
                :key="'workingPracticeActivities' + index"
              >
                <el-input
                  class="dot_textbox"
                  v-model="item.selection"
                  style="width: 90%;"
                /><i
                  class="el-icon-remove delete_aleveldetails"
                  style="color: #dc3c3c; font-size: 20px"
                  @click="
                    deleteField(
                      index,
                      setting.profileConfiguration.coreStrengthInformation
                        .activitiesValue.workingPracticeActivities
                    )
                  "
                ></i>
              </div>
              <el-checkbox
                v-model="
                  setting.profileConfiguration.coreStrengthInformation
                    .sectorExperience
                "
                :disabled="setting.profileName == 'Default' ? true : false"
                >Sector Experiences</el-checkbox
              >
              <i
                v-show="
                  setting.profileConfiguration.coreStrengthInformation
                    .sectorExperience
                "
                class="el-icon-circle-plus add_oleveldetails"
                style="color: #13ce66; font-size: 20px; float: right; margin-right:10%; top:10px; padding:2px;"
                @click="
                  addSectorExperience(
                    setting.profileConfiguration.personalInformation.education
                      .sectorExperienceValue.experienceDetails
                  )
                "
              ></i>
              <br />
              <div
                v-show="
                  setting.profileConfiguration.coreStrengthInformation
                    .sectorExperience
                "
                v-for="(item, index) in setting.profileConfiguration
                  .personalInformation.education.sectorExperienceValue
                  .experienceDetails"
                :key="'experienceDetails' + index"
              >
                <el-input
                  class="dot_textbox"
                  v-model="item.title"
                  style="width: 90%;"
                /><i
                  class="el-icon-remove delete_aleveldetails"
                  style="color: #dc3c3c; font-size: 20px"
                  @click="
                    deleteField(
                      index,
                      setting.profileConfiguration.personalInformation.education
                        .sectorExperienceValue.experienceDetails
                    )
                  "
                ></i>
              </div>
              <el-checkbox
                v-model="
                  setting.profileConfiguration.coreStrengthInformation.knowledge
                "
                :disabled="setting.profileName == 'Default' ? true : false"
                >Knowledge</el-checkbox
              ><i
                v-show="
                  setting.profileConfiguration.coreStrengthInformation.knowledge
                "
                class="el-icon-circle-plus add_oleveldetails"
                style="color: #13ce66; font-size: 20px; float: right; margin-right:10%; top:10px; padding:2px;"
                @click="
                  addKnowledge(
                    setting.profileConfiguration.coreStrengthInformation
                      .knowledgeValue.knowledgeRegularlyUsed
                  )
                "
              ></i>
              <br />
              <div
                v-show="
                  setting.profileConfiguration.coreStrengthInformation.knowledge
                "
                v-for="(item, index) in this.setting.profileConfiguration
                  .coreStrengthInformation.knowledgeValue
                  .knowledgeRegularlyUsed"
                :key="'knowledgeRegularlyUsed' + index"
              >
                <el-input
                  class="dot_textbox"
                  v-model="item.selection"
                  style="width: 90%;"
                /><i
                  class="el-icon-remove delete_aleveldetails"
                  style="color: #dc3c3c; font-size: 20px"
                  @click="
                    deleteField(
                      index,
                      setting.profileConfiguration.coreStrengthInformation
                        .knowledgeValue.knowledgeRegularlyUsed
                    )
                  "
                ></i>
              </div>
              <el-checkbox
                v-model="
                  setting.profileConfiguration.coreStrengthInformation
                    .essentialSkills
                "
                :disabled="setting.profileName == 'Default' ? true : false"
                >Essential Skills</el-checkbox
              ><i
                v-show="
                  setting.profileConfiguration.coreStrengthInformation
                    .essentialSkills
                "
                class="el-icon-circle-plus add_oleveldetails"
                style="color: #13ce66; font-size: 20px; float: right; margin-right:10%; top:10px; padding:2px;"
                @click="
                  addEssentialSkills(
                    setting.profileConfiguration.coreStrengthInformation
                      .essentialSkillsValue.mindsets
                  )
                "
              ></i>
              <br />
              <div
                v-show="
                  setting.profileConfiguration.coreStrengthInformation
                    .essentialSkills
                "
                v-for="(item, index) in this.setting.profileConfiguration
                  .coreStrengthInformation.essentialSkillsValue.mindsets"
                :key="'mindsets' + index"
              >
                <el-input
                  class="dot_textbox"
                  v-model="item.selection"
                  style="width: 90%;"
                /><i
                  class="el-icon-remove delete_aleveldetails"
                  style="color: #dc3c3c; font-size: 20px"
                  @click="
                    deleteField(
                      index,
                      setting.profileConfiguration.coreStrengthInformation
                        .essentialSkillsValue.mindsets
                    )
                  "
                ></i>
              </div>
              <el-checkbox
                v-model="
                  setting.profileConfiguration.coreStrengthInformation.skills
                "
                :disabled="setting.profileName == 'Default' ? true : false"
                >Skills</el-checkbox
              ><i
                v-show="
                  setting.profileConfiguration.coreStrengthInformation.skills
                "
                class="el-icon-circle-plus add_oleveldetails"
                style="color: #13ce66; font-size: 20px; float: right; margin-right:10%; top:10px; padding:2px;"
                @click="
                  addSkill(
                    setting.profileConfiguration.coreStrengthInformation
                      .skillsValue.workingPracticeSkills
                  )
                "
              ></i>
              <br />
              <div
                v-show="
                  setting.profileConfiguration.coreStrengthInformation.skills
                "
                v-for="(item, index) in this.setting.profileConfiguration
                  .coreStrengthInformation.skillsValue.workingPracticeSkills"
                :key="'workingPracticeSkills' + index"
              >
                <el-input
                  class="dot_textbox"
                  v-model="item.selection"
                  style="width: 90%;"
                /><i
                  class="el-icon-remove delete_aleveldetails"
                  style="color: #dc3c3c; font-size: 20px"
                  @click="
                    deleteField(
                      index,
                      setting.profileConfiguration.coreStrengthInformation
                        .skillsValue.workingPracticeSkills
                    )
                  "
                ></i>
              </div>
              <el-checkbox
                v-model="
                  setting.profileConfiguration.coreStrengthInformation
                    .hiddenTalents
                "
                :disabled="setting.profileName == 'Default' ? true : false"
              >
                <el-tooltip placement="top">
                  <span style="font-size: 12px">
                    Hidden Talents <i class="fas fa-info-circle"></i>
                  </span>
                  <div slot="content">
                    Promote yourself <br /><br />
                    <ul>
                      <li>
                        Be sure to add in all the great skills you have from
                        things you do outside of work….
                      </li>
                      <li>
                        Stay at home parent, caregiver to a family member,
                        volunteering
                      </li>
                      <li>Scheduling of appointments</li>
                      <li>Organization</li>
                      <li>Coordinating visits</li>
                      <li>Budgeting</li>
                    </ul>
                    Skills aren’t just gained through work, don’t sell yourself
                    short!
                  </div>
                </el-tooltip> </el-checkbox
              ><i
                v-show="
                  setting.profileConfiguration.coreStrengthInformation
                    .hiddenTalents
                "
                class="el-icon-circle-plus add_oleveldetails"
                style="color: #13ce66; font-size: 20px; float: right; margin-right:10%; top:10px; padding:2px;"
                @click="
                  addHiddenTalent(
                    setting.profileConfiguration.coreStrengthInformation
                      .hiddenTalentsValue.skillsKnowledgeOutsideWork
                  )
                "
              ></i
              ><br />
              <div
                v-show="
                  setting.profileConfiguration.coreStrengthInformation
                    .hiddenTalents
                "
                v-for="(item, index) in this.setting.profileConfiguration
                  .coreStrengthInformation.hiddenTalentsValue
                  .skillsKnowledgeOutsideWork"
                :key="'skillsKnowledgeOutsideWork' + index"
              >
                <el-input
                  class="dot_textbox"
                  v-model="
                    setting.profileConfiguration.coreStrengthInformation
                      .hiddenTalentsValue.skillsKnowledgeOutsideWork[index]
                  "
                  style="width: 90%;"
                /><i
                  class="el-icon-remove delete_aleveldetails"
                  style="color: #dc3c3c; font-size: 20px"
                  @click="
                    deleteField(
                      index,
                      setting.profileConfiguration.coreStrengthInformation
                        .hiddenTalentsValue.skillsKnowledgeOutsideWork
                    )
                  "
                ></i>
              </div>

              <!-- Technology Section -->
              <el-checkbox
                v-model="
                  setting.profileConfiguration.coreStrengthInformation.technologies
                "
                :disabled="setting.profileName == 'Default' ? true : false"
                >Technology</el-checkbox
              ><i
                v-show="
                  setting.profileConfiguration.coreStrengthInformation.technologies
                "
                class="el-icon-circle-plus add_oleveldetails"
                style="
                  color: #13ce66;
                  font-size: 20px;
                  float: right;
                  margin-right: 10%;
                  top: 10px;
                  padding: 2px;
                "
                @click="
                  addTechnologies(
                    setting.profileConfiguration.coreStrengthInformation
                      .technologiesValue.userTechnologies
                  )
                "
              ></i>
              <br />
              <div
                v-show="
                  setting.profileConfiguration.coreStrengthInformation.technologies
                "
                v-for="(item, index) in this.setting.profileConfiguration
                  .coreStrengthInformation.technologiesValue.userTechnologies"
                :key="'userTechnologies' + index"
              >
                <el-input
                  class="dot_textbox"
                  v-model="item.selection"
                  style="width: 90%"
                /><i
                  class="el-icon-remove delete_aleveldetails"
                  style="color: #dc3c3c; font-size: 20px"
                  @click="
                    deleteField(
                      index,
                      setting.profileConfiguration.coreStrengthInformation
                        .technologiesValue.userTechnologies
                    )
                  "
                ></i>
              </div>

            </el-col>
          </el-col>

          <el-col :xl="3" :lg="3" :md="3" :sm="3" :xs="24">
            <el-row>
              <el-col>
                <span
                  v-if="!create"
                  class="dialog-footer ts-app-shell--header_actions flexed"
                  style="padding-top:10px;padding-bottom:50px;"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Sync this resume with your Profile"
                    placement="top"
                  >
                    <el-button
                      class="ts-btn-small ts-btn-white"
                      @click.prevent="refresh(setting)"
                      ><i class="fas fa-sync"></i
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Download this resume's QR Code"
                    placement="top"
                  >
                    <el-button
                      class="ts-btn-small ts-btn-white"
                      @click.prevent="download"
                      ><i class="fas fa-qrcode"></i
                    ></el-button>
                  </el-tooltip>
                  <el-button
                    class="ts-btn-small ts-btn-white"
                    style="visibility:hidden;"
                    v-if="setting.profileName == 'Default'"
                    ><i class="fas fa-trash-alt"></i
                  ></el-button>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Delete this resume"
                    placement="top"
                    v-else
                  >
                    <el-button
                      class="ts-btn-small ts-btn-white"
                      @click.prevent="removeSetting(setting)"
                      ><i class="fas fa-trash-alt"></i
                    ></el-button>
                  </el-tooltip>
                </span>
                <span
                  v-else
                  class="dialog-footer ts-app-shell--header_actions flexed spacer"
                  style="padding-top:10px;padding-bottom:50px;"
                >
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row style="padding: 0px 10px 10px 10px;">
          <el-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
            <el-tooltip
              class="item"
              effect="dark"
              style="padding-left: 5px;"
              placement="top"
            >
              <div slot="content">
                <span style="font-weight: bold;"
                  >A personal statement is a brief personal summary given to
                  prospective employers <br />
                  to help you stand apart from the competition</span
                ><br /><br />
                <ul>
                  <li>Who are you?</li>
                  <li>What can you offer?</li>
                  <li>What are your career goals?</li>
                </ul>
                <span style="font-weight: bold;"
                  >Your personal statement can be written in any person or tense
                  <br />
                  - as long as you maintain consistency throughout.
                </span>
              </div>
              <span class="setting-title">Personal Statement &nbsp; </span>
            </el-tooltip>
            <a
              style="color: #409eff"
              href="https://www.reed.co.uk/career-advice/personal-statement-examples/?__cf_chl_captcha_tk__=pmd_4abaaa1471b2be9d94abacbb573a45447860a607-1629092180-0-gqNtZGzNAuKjcnBszQiO"
              target="_blank"
              ><i class="fas fa-question-circle"></i></a
            ><br />
            <el-input
              v-if="create"
              class="txtArea"
              type="textarea"
              v-model="personalStatement"
              rows="5"
              placeholder="Please tell something about yourself.."
              show-word-limit
              maxlength="150"
            >
            </el-input>
            <el-input
              v-else
              class="txtArea"
              type="textarea"
              v-model="setting.profileConfiguration.personalStatement"
              rows="5"
              placeholder="Please tell something about yourself.."
              show-word-limit
              maxlength="150"
            >
            </el-input>
            <br /><br />
            <el-switch
              style="padding-left:10px;"
              v-model="setting.isActive"
              @change="chooseThisSetting(setting)"
              active-text="Set the resume to Active"
            ></el-switch>
            <el-switch
              style="padding-left:10px;"
              v-model="setting.displayInitials"
              @change="chooseThisSetting(setting)"
              active-text="Display my name as initials"
            ></el-switch>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
            <el-row>
              <br />
            </el-row>
            <el-row v-if="create">
              <!-- <el-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
                <br>
              </el-col> -->
              <el-col :xl="25" :lg="25" :md="25" :sm="24" :xs="24">
                <span class="dialog-footer">
                  <button
                    class="ts-btn ts-btn-small"
                    style="width: 100px; float: right; margin-right: 10px;"
                    @click.prevent="cancelSettings(setting)"
                  >
                    Cancel
                  </button>
                  <button
                    class="ts-btn ts-btn-small"
                    style="width: 100px; float: right; margin-right: 10px;"
                    @click.prevent="saveSettings(setting)"
                    :class="{ loading: btnLoading }"
                  >
                    <i> <v-icon name="circle-notch" /> </i> Save
                  </button>
                </span>
              </el-col>
            </el-row>
            <el-row v-else class="narrow">
              <!-- <el-col :xl="15" :lg="15" :md="15" :sm="24" :xs="24">
                <br>
              </el-col> -->
              <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                <span class="dialog-footer">
                  <button
                    class="ts-btn ts-btn-small"
                    style="width: 100px; float: right; margin-right: 10px;"
                    @click.prevent="cancelUpdateSetting(setting)"
                  >
                    Cancel
                  </button>
                  <button
                    class="ts-btn ts-btn-small"
                    style="width: 100px; float: right; margin-right: 10px;"
                    @click.prevent="saveUpdateSetting(setting)"
                    :class="{ loading: btnLoading }"
                  >
                    <i> <v-icon name="circle-notch" /> </i> Save
                  </button>
                </span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-dialog
          title="Estimated Graduation Date"
          :visible.sync="showDateModal"
          :close-on-click-modal="false"
          :show-close="false"
          width="500px"
          class="ts-modal"
        >
          <button
            type="button"
            aria-label="Close"
            class="el-dialog__headerbtn"
            @click="closeDateModal"
          >
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>
          <el-form @submit.native.prevent style="margin-top: -10px;">
            <el-form-item :error="selectedGradDateError" :required="true">
              <p style="margin-bottom: 0px;">
                Please enter estimated graduation date:
              </p>
              <el-date-picker
                v-model="selectedGradDate"
                type="date"
                format="MM-dd-yyyy"
                placeholder="Select date and time"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>

          <el-row type="flex">
            <el-col :offset="8" :xl="5" :lg="5" :ms="5" :sm="5" :xs="5">
              <el-button
                @click="closeDateModal"
                style="width:80px"
                class="ts-btn ts-btn-small ts-btn-white"
                >Cancel</el-button
              >
            </el-col>
            <el-col :xl="5" :lg="5" :ms="5" :sm="5" :xs="5">
              <el-button
                @click="setGraduationDate"
                style="width:80px"
                class="ts-btn ts-btn-small ts-btn-primary"
                >Ok</el-button
              >
            </el-col>
          </el-row>
        </el-dialog>
      </el-form>

      <div hidden>
        <div class="center" id="qr-canvas-setting">
          <qrcode-vue
            :value="createqrcodeLink"
            :size="size"
            level="H"
            style="text-align:center"
          ></qrcode-vue>
        </div>
        &nbsp;&nbsp;
        <div
          style="text-align:center; color:blue; text-decoration:underline;"
          ref="pdflink"
        >
          <span>{{ createqrcodeLink }}</span>
        </div>

        <img src="~../assets/img/the-logo.png" id="talent-sensus-icon" />
        <img src="~../assets/img/qr-scan-1.png" id="qr-scan-1-icon" />
        <img src="~../assets/img/qr-scan-2.png" id="qr-scan-2-icon" />
        <img src="~../assets/img/qr-scan-3.png" id="qr-scan-3-icon" />
        <img src="~../assets/img/cut-here.png" id="cut-here-icon" />
        <img src="~../assets/img/qr-card1.png" id="qr-card-icon1" />
        <img src="~../assets/img/qr-card2.png" id="qr-card-icon2" />
        <img src="~../assets/img/qr-board.png" id="qr-board" />
        <img src="~../assets/img/logos/us-logo-circle.png" id="ts-logo" />
        <img
          src="~../assets/img/logos/background-logo-circle.png"
          id="user-logo"
        />

        <input id="tsIcon" />
        <input id="qrScan1" />
        <input id="qrScan2" />
        <input id="qrScan3" />
        <input id="cutHere" />
        <input id="qrCard1" />
        <input id="qrCard2" />
        <input id="qrBoard" />
        <input id="tslogo" />
        <input id="userlogo" />
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import QrcodeVue from "qrcode.vue";
import jsPDF from "jspdf";

const educationOptions = ["SecondaryLevel", "ThirdLevel", "FourthLevel"];
export default {
  props: {
    setting: {
      type: Object,
      default() {
        return {};
      }
    },
    settings: {
      type: Array,
      default() {
        return [];
      }
    },
    create: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  updated: function() {
    // var tasks = this.setting.ProfileConfiguration.CoreStrengthInformation.TaskDutiesValue.JobDescriptionTasks;
    // var idx = 0;
    // tasks.forEach(element => {
    //   if(element.split('`')[1] == undefined)
    //   {
    //     this.setting.ProfileConfiguration.CoreStrengthInformation.TaskDutiesValue.JobDescriptionTasks[idx] = this.formattedTask[idx];
    //   }else{
    //     this.setting.ProfileConfiguration.CoreStrengthInformation.TaskDutiesValue.JobDescriptionTasks[idx] = this.formattedTask[idx] + '`' + element.split('`')[1];
    //   }
    //   idx++;
    // });
  },
  mounted: function() {
    var tasks = this.setting.profileConfiguration.coreStrengthInformation
      .taskDutiesValue.jobDescriptionTasks;
    var idx = 0;
    tasks.forEach(element => {
      this.formattedTask[idx] =
        element.indexOf("`") > -1 ? element.split("`")[0] : element;
      idx++;
    });

    this.$nextTick(function() {
      // Code that will run only after the
      // entire view has been rendered
      const usLogo = document.querySelector("#talent-sensus-icon");
      this.toDataURLCustom(usLogo.src, function(dataUrl) {
        document.getElementById("tsIcon").value = dataUrl;
      });

      const qrLogo1 = document.querySelector("#qr-scan-1-icon");
      this.toDataURLCustom(qrLogo1.src, function(dataUrl) {
        document.getElementById("qrScan1").value = dataUrl;
      });

      const qrLogo2 = document.querySelector("#qr-scan-2-icon");
      this.toDataURLCustom(qrLogo2.src, function(dataUrl) {
        document.getElementById("qrScan2").value = dataUrl;
      });

      const qrLogo3 = document.querySelector("#qr-scan-3-icon");
      this.toDataURLCustom(qrLogo3.src, function(dataUrl) {
        document.getElementById("qrScan3").value = dataUrl;
      });

      const cutLogo = document.querySelector("#cut-here-icon");
      this.toDataURLCustom(cutLogo.src, function(dataUrl) {
        document.getElementById("cutHere").value = dataUrl;
      });

      const cardLogo1 = document.querySelector("#qr-card-icon1");
      this.toDataURLCustom(cardLogo1.src, function(dataUrl) {
        document.getElementById("qrCard1").value = dataUrl;
      });

      const cardLogo2 = document.querySelector("#qr-card-icon2");
      this.toDataURLCustom(cardLogo2.src, function(dataUrl) {
        document.getElementById("qrCard2").value = dataUrl;
      });

      const cardBoard = document.querySelector("#qr-board");
      this.toDataURLCustom(cardBoard.src, function(dataUrl) {
        document.getElementById("qrBoard").value = dataUrl;
      });

      const rightLogo = document.querySelector("#ts-logo");
      this.toDataURLCustom(rightLogo.src, function(dataUrl) {
        document.getElementById("tslogo").value = dataUrl;
      });

      const leftLogo = document.querySelector("#user-logo");
      this.toDataURLCustom(leftLogo.src, function(dataUrl) {
        document.getElementById("userlogo").value = dataUrl;
      });
    });
  },
  components: {
    QrcodeVue
  },
  computed: {
    userAPI() {
      const isApprentice = this.$store.state.account.current_user.roles.includes(
        "Apprentice"
      );
      if (isApprentice) {
        return "apprentice";
      } else {
        return "jobseeker";
      }
    },
    createqrcodeLink() {
      return (
        window.location.host +
        "/profile/" +
        this.currentUser.id +
        "/" +
        this.$props.setting.id
      );
    },
    currentUser() {
      // if(this.$store.state.apprentice.current_user) {
      //   return this.$store.state.account.current_user;
      // } else {
      //   return this.$store.state.account.current_user;
      // }
      return this.$store.state.account.current_user;
    },
    educationHaveTrue() {
      var education = this.$props.setting.profileConfiguration
        .personalInformation.education;
      if (
        education.secondaryLevel &&
        education.thirdLevel &&
        education.fourthLevel
      ) {
        this.isIndeterminate = false;
        this.checkAll = true;
      } else if (
        !education.secondaryLevel &&
        !education.thirdLevel &&
        !education.fourthLevel
      ) {
        this.isIndeterminate = false;
        this.checkAll = false;
      } else {
        this.isIndeterminate = true;
      }
    }
  },
  data() {
    return {
      showSecondaryModal: false,
      checkAll: false,
      checkedEducations: ["SecondaryLevel", "ThirdLevel"],
      educations: educationOptions,
      isIndeterminate: false,
      settingNameError: null,
      cancelItem: {},
      queueId: {},
      size: 200,
      personalStatement: null,
      btnLoading: false,
      _hiddentalents: [],
      controlTitle: "",
      showControl: false,
      dynamicProp: {},
      dynamicObj: {},
      fieldToAdd: [],
      controlDesc: "",
      _element: [],
      formattedTask: [],
      showDateModal: false,
      optionToSetDate: null,
      selectedGradDate: null,
      elementIndex: 0,
      htmlElem: null,
      selectedGradDateError: null,
      isFromElementUI: false,
      targetIndex: null
    };
  },
  methods: {
    addSecondaryModal() {
      this.showSecondaryModal = true;
    },
    closeSecondaryModal() {
      this.showSecondaryModal = false;
    },
    addSecondaryEducation() {
      this.closeSecondaryModal();
    },
    validateRequiredFields(obj) {
      if (this.controlTitle == "Certificate") {
        if (obj.codeDetailDesc == null || obj.codeDetailDesc == "") {
          this.showErrorMessage("Description is required");
          return true;
        }
      } else if (
        this.controlTitle == "A-Level" ||
        this.controlTitle == "O-Level"
      ) {
        if (obj.subject == null || obj.subject == "") {
          this.showErrorMessage("Subject is required");
          return true;
        } else if (obj.grade == null) {
          this.showErrorMessage("Grade is required");
          return true;
        }
      } else if (
        this.controlTitle == "Associate Degree" ||
        this.controlTitle == "Bachelors Degree" ||
        this.controlTitle == "Masters Degree" ||
        this.controlTitle == "Doctoral Degree"
      ) {
        if (obj.courseTitle == null || obj.courseTitle == "") {
          this.showErrorMessage("Course Title is required");
          return true;
        }
      } else if (this.controlTitle == "Sector Experience") {
        if (obj.title == null || obj.title == "") {
          this.showErrorMessage("Title is required");
          return true;
        } else if (obj.years == null) {
          this.showErrorMessage("Years is required");
          return true;
        }
      } else if (this.controlTitle == "Work History") {
        if (obj.jobTitle == null || obj.jobTitle == "") {
          this.showErrorMessage("Job Title is required");
          return true;
        }
      } else if (
        this.controlTitle == "Task/Duties" ||
        this.controlTitle == "Hidden Talent" ||
        this.controlTitle == "Job Title"
      ) {
        if (obj.array == null || obj.array == "") {
          this.showErrorMessage("Description is required");
          return true;
        }
      } else if (
        this.controlTitle == "Activities" ||
        this.controlTitle == "Essential Skill"
      ) {
        if (obj.selection == null || obj.selection == "") {
          this.showErrorMessage("Description is required");
          return true;
        }
      } else if (
        this.controlTitle == "Knowledge" ||
        this.controlTitle == "Skill" ||
        this.controlTitle == "Technology"
      ) {
        if (obj.selection == null || obj.selection == "") {
          this.showErrorMessage("Description is required");
          return true;
        } else if (obj.yearsOfExperience == null) {
          this.showErrorMessage("Years of experience is required");
          return true;
        }
      }
    },
    showErrorMessage(errMsg) {
      this.$confirm(
        `<p style="text-align:center;padding-bottom:20px;">` + errMsg + `</p>`,
        "Warning",
        {
          confirmButtonText: "OK",
          showCancelButton: false,
          type: "warning",
          dangerouslyUseHTMLString: true,
          center: true
        }
      ).then(() => {});
    },
    addField(obj) {
      var hasError = this.validateRequiredFields(obj);
      if (hasError) {
        return false;
      } else {
        if (
          this.controlTitle == "Activities" ||
          this.controlTitle == "Knowledge" ||
          this.controlTitle == "Essential Skill" ||
          this.controlTitle == "Skill"
        ) {
          obj.value = "OUT";
        }

        if (this.controlTitle == "Certificate") {
          if (obj.acquiredDt == undefined) obj.acquiredDt = null;
          if (obj.expirationDt == undefined) obj.expirationDt = null;
          if (obj.noExpiration == undefined) obj.noExpiration = false;
          // if(obj.Description == undefined)obj.Description = null;
        }

        if (
          this.controlTitle == "Sector Experience" ||
          this.controlTitle == "O-Level" ||
          this.controlTitle == "A-Level" ||
          this.controlTitle == "Associate Degree" ||
          this.controlTitle == "Bachelors Degree" ||
          this.controlTitle == "Masters Degree" ||
          this.controlTitle == "Doctoral Degree"
        ) {
          obj.required = false;
        }

        if (obj.array != undefined) {
          this.fieldToAdd.push(obj.array);
        } else {
          this.fieldToAdd.push(obj);
        }

        if (this.controlTitle == "Task/Duties") {
          this.formattedTask.push(obj.array);
        }

        this.closeAddControl();
      }
    },
    deleteField(index, field, isTask, control) {
      var item = field;
      if (
        item.length <= 1 &&
        control != "Certificate" &&
        control != "Sector Experience" &&
        control != "O-Level" &&
        control != "A-Level" &&
        control != "Associate Degree" &&
        control != "Bachelors Degree" &&
        control != "Masters Degree" &&
        control != "Doctoral Degree"
      ) {
        this.$confirm(
          `<p style="text-align:center;padding-bottom:20px;">You have to maintain at least one item to show in your resume</p>`,
          "Warning",
          {
            confirmButtonText: "OK",
            showCancelButton: false,
            type: "warning",
            dangerouslyUseHTMLString: true,
            center: true
          }
        ).then(() => {
          return false;
        });
      } else {
        item.splice(index, 1);

        //repoppulate formatted task based on current setting value
        if (isTask) {
          var tasks = this.setting.profileConfiguration.coreStrengthInformation
            .taskDutiesValue.jobDescriptionTasks;
          var idx = 0;
          this.formattedTask = [];
          tasks.forEach(element => {
            this.formattedTask[idx] =
              element.indexOf("`") > -1 ? element.split("`")[0] : element;
            idx++;
          });
        }
      }
    },
    closeAddControl() {
      this.showControl = false;
      this.fieldToAdd = [];
      this.dynamicProp = {};
      this.dynamicObj = {};
      this._type = [];
      this.controlTitle = "";
      this.controlDesc = "";
    },
    showAddControl(obj, field, certWork) {
      this.fieldToAdd = field;
      this.showControl = true;
      if (certWork == "work") {
        var work = [
          "employerVisible",
          "employer",
          "workedFromVisible",
          "workedFrom",
          "workedToVisible",
          "workedTo",
          "workedToPresent",
          "jobTitleVisible",
          "jobTitle",
          "employerAddressVisible",
          "employerAddress",
          "employerNumberVisible",
          "employerNumber"
        ];

        this.dynamicProp = work;
      } else if (certWork == "cert") {
        this.dynamicProp =
          typeof obj === "object" ? Object.keys(obj).sort() : ["array"];
      } else {
        this.dynamicProp =
          typeof obj === "object" ? Object.keys(obj).sort() : ["array"];
      }
    },
    addWorkHistory(item) {
      this._element = [];
      this._element.push({
        type: "boolean",
        display: true,
        Title: "Show Employer"
      }); //EmployerVisible
      this._element.push({ type: "string", display: true, Title: "Employer" }); //Employer
      this._element.push({
        type: "boolean",
        display: true,
        Title: "Show Start Date"
      }); //WorkedFromVisible
      this._element.push({ type: "date", display: true, Title: "Start Date" }); //WorkedFrom
      this._element.push({
        type: "boolean",
        display: true,
        Title: "Show End Date"
      }); //WorkedToVisible
      this._element.push({ type: "date", display: true, Title: "End Date" }); //WorkedTo
      this._element.push({
        type: "boolean",
        display: true,
        Title: "To Present"
      }); //WorkedToPresent
      this._element.push({
        type: "boolean",
        display: true,
        Title: "Show Job Title"
      }); //JobTitleVisible
      this._element.push({ type: "string", display: true, Title: "Job Title" }); //JobTitle
      this._element.push({
        type: "boolean",
        display: true,
        Title: "Show Employer Address"
      }); //EmployerAddressVisible
      this._element.push({
        type: "string",
        display: true,
        Title: "Employer Address"
      }); //EmployerAddress
      this._element.push({
        type: "boolean",
        display: true,
        Title: "Show Employer Number"
      }); //EmployerNumberVisible
      this._element.push({
        type: "string",
        display: true,
        Title: "Employer Number"
      }); //EmployerNumber

      this.controlTitle = "Work History";
      this.controlDesc = "Enter additional work history to your resume";

      this.showAddControl(item[0], item, "work");
    },
    addJobTitle(item) {
      if (item.length >= 3) {
        this.$confirm(
          `<p style="text-align:center;padding-bottom:20px;">You can only add up to 3 job titles in your resume</p>`,
          "Warning",
          {
            confirmButtonText: "OK",
            showCancelButton: false,
            type: "warning",
            dangerouslyUseHTMLString: true,
            center: true
          }
        ).then(() => {});
      } else {
        this._element = [];
        this._element.push({
          type: "string",
          display: true,
          Title: "Description"
        }); //Description

        this.controlTitle = "Job Title";
        this.controlDesc = "Enter additional job title to your resume";
        this.showAddControl(item[0], item);
      }
    },
    addTask(item) {
      this._element = [];
      this._element.push({
        type: "string",
        display: true,
        Title: "Description"
      }); //Description

      this.controlTitle = "Task/Duties";
      this.controlDesc = "Enter additional task or duties to your resume";

      this.showAddControl(item[0], item);
    },
    addCertification(item) {
      this._element = [];
      this._element.push({
        type: "date",
        display: true,
        Title: "Acquired Date"
      }); //AcquiredDt
      this._element.push({
        type: "string",
        display: true,
        Title: "Description"
      }); //CodeDetailDesc
      this._element.push({
        type: "date",
        display: true,
        Title: "Expiration Date"
      }); //ExpirationDt
      this._element.push({
        type: "boolean",
        display: true,
        Title: "No Expiration"
      }); //NoExpiration
      this._element.push({
        type: "string",
        display: false,
        Title: "Description"
      }); //Description

      this.controlTitle = "Certificate";
      this.controlDesc = "Enter additional certification to your resume";

      if (item == undefined || item.length == 0) {
        //undefined is from create default resume, length 0 is from sync from sga
        var column = {
          acquiredDt: null,
          codeDetailDesc: "",
          expirationDt: null,
          noExpiration: false
          // Description: '',
        };

        this.setting.profileConfiguration.personalInformation.certificationsValue.userCertifications = [];
        this.showAddControl(
          column,
          this.setting.profileConfiguration.personalInformation
            .certificationsValue.userCertifications
        );
      } else {
        this.showAddControl(item[0], item);
      }
    },
    addOLevel(item) {
      this._element = [];
      this._element.push({ type: "grade", display: true, Title: "Grade" }); //Grade
      this._element.push({
        type: "boolean",
        display: false,
        Title: "Required"
      }); //Required
      this._element.push({ type: "string", display: true, Title: "Subject" }); //Subject

      this.controlTitle = "O-Level";
      this.controlDesc = "Enter additional o-level education to your resume";

      if (item == undefined || item.length == 0) {
        //undefined is from create default resume, length 0 is from sync from sga
        var column = {
          grade: "",
          required: false,
          subject: ""
        };

        this.setting.profileConfiguration.personalInformation.education.secondaryLevelValue.oLevelDetailsValue = [];
        this.showAddControl(
          column,
          this.setting.profileConfiguration.personalInformation.education
            .secondaryLevelValue.oLevelDetailsValue
        );
      } else {
        this.showAddControl(item[0], item);
      }
    },
    addALevel(item) {
      this._element = [];
      this._element.push({ type: "grade", display: true, Title: "Grade" }); //Grade
      this._element.push({
        type: "boolean",
        display: false,
        Title: "Required"
      }); //Required
      this._element.push({ type: "string", display: true, Title: "Subject" }); //Subject

      this.controlTitle = "A-Level";
      this.controlDesc = "Enter additional a-level education to your resume";

      if (item == undefined || item.length == 0) {
        //undefined is from create default resume, length 0 is from sync from sga
        var column = {
          grade: "",
          required: false,
          subject: ""
        };

        this.setting.profileConfiguration.personalInformation.education.secondaryLevelValue.aLevelDetailsValue = [];
        this.showAddControl(
          column,
          this.setting.profileConfiguration.personalInformation.education
            .secondaryLevelValue.aLevelDetailsValue
        );
      } else {
        this.showAddControl(item[0], item);
      }
    },
    addAssociateDegree(item) {
      this._element = [];
      this._element.push({
        type: "string",
        display: true,
        Title: "Course Title"
      }); //CourseTitle
      this._element.push({
        type: "boolean",
        display: false,
        Title: "Required"
      }); //Required
      this._element.push({
        type: "boolean",
        display: false,
        Title: "CurrentlyAttending"
      }); //CurrentlyAttending
      this._element.push({
        type: "datetime",
        display: false,
        Title: "GraduationDate"
      }); //GraduationDate

      this.controlTitle = "Associate Degree";
      this.controlDesc = "Enter additional associate degree to your resume";

      if (item == undefined || item.length == 0) {
        //undefined is from create default resume, length 0 is from sync from sga
        var column = {
          courseTitle: "",
          required: false,
          currentlyAttending: false,
          graduationDate: null
        };

        this.setting.profileConfiguration.personalInformation.education.thirdLevelValue.associateDegreeDetails = [];
        this.showAddControl(
          column,
          this.setting.profileConfiguration.personalInformation.education
            .thirdLevelValue.associateDegreeDetails
        );
      } else {
        this.showAddControl(item[0], item);
      }
    },
    addBachelorsDegree(item) {
      this._element = [];
      this._element.push({
        type: "string",
        display: true,
        Title: "Course Title"
      }); //CourseTitle
      this._element.push({
        type: "boolean",
        display: false,
        Title: "Required"
      }); //Required
      this._element.push({
        type: "boolean",
        display: false,
        Title: "CurrentlyAttending"
      }); //CurrentlyAttending
      this._element.push({
        type: "datetime",
        display: false,
        Title: "GraduationDate"
      }); //GraduationDate

      this.controlTitle = "Bachelors Degree";
      this.controlDesc = "Enter additional bachelors degree to your resume";

      if (item == undefined || item.length == 0) {
        //undefined is from create default resume, length 0 is from sync from sga
        var column = {
          courseTitle: "",
          required: false,
          currentlyAttending: false,
          graduationDate: null
        };

        this.setting.profileConfiguration.personalInformation.education.thirdLevelValue.bachelorsDegreeDetails = [];
        this.showAddControl(
          column,
          this.setting.profileConfiguration.personalInformation.education
            .thirdLevelValue.bachelorsDegreeDetails
        );
      } else {
        this.showAddControl(item[0], item);
      }
    },
    addMastersDegree(item) {
      this._element = [];
      this._element.push({
        type: "string",
        display: true,
        Title: "Course Title"
      }); //CourseTitle
      this._element.push({
        type: "boolean",
        display: false,
        Title: "Required"
      }); //Required
      this._element.push({
        type: "boolean",
        display: false,
        Title: "CurrentlyAttending"
      }); //CurrentlyAttending
      this._element.push({
        type: "datetime",
        display: false,
        Title: "GraduationDate"
      }); //GraduationDate

      this.controlTitle = "Masters Degree";
      this.controlDesc = "Enter additional masters degree to your resume";

      if (item == undefined || item.length == 0) {
        //undefined is from create default resume, length 0 is from sync from sga
        var column = {
          courseTitle: "",
          required: false,
          currentlyAttending: false,
          graduationDate: null
        };

        this.setting.profileConfiguration.personalInformation.education.fourthLevelValue.mastersDegreeDetails = [];
        this.showAddControl(
          column,
          this.setting.profileConfiguration.personalInformation.education
            .fourthLevelValue.mastersDegreeDetails
        );
      } else {
        this.showAddControl(item[0], item);
      }
    },
    addDoctoralDegree(item) {
      this._element = [];
      this._element.push({
        type: "string",
        display: true,
        Title: "Course Title"
      }); //CourseTitle
      this._element.push({
        type: "boolean",
        display: false,
        Title: "Required"
      }); //Required
      this._element.push({
        type: "boolean",
        display: false,
        Title: "CurrentlyAttending"
      }); //CurrentlyAttending
      this._element.push({
        type: "datetime",
        display: false,
        Title: "GraduationDate"
      }); //GraduationDate

      this.controlTitle = "Doctoral Degree";
      this.controlDesc = "Enter additional doctoral degree to your resume";

      if (item == undefined || item.length == 0) {
        //undefined is from create default resume, length 0 is from sync from sga
        var column = {
          courseTitle: "",
          required: false,
          currentlyAttending: false,
          graduationDate: null
        };

        this.setting.profileConfiguration.personalInformation.education.fourthLevelValue.doctoralDegreeDetails = [];
        this.showAddControl(
          column,
          this.setting.profileConfiguration.personalInformation.education
            .fourthLevelValue.doctoralDegreeDetails
        );
      } else {
        this.showAddControl(item[0], item);
      }
    },
    addActivities(item) {
      this._element = [];
      this._element.push({
        type: "number",
        display: false,
        Title: "Match Count"
      }); //MatchCount
      this._element.push({
        type: "string",
        display: true,
        Title: "Description"
      }); //Selection
      this._element.push({
        type: "string",
        display: false,
        Title: "I add to role"
      }); //Value

      this.controlTitle = "Activities";
      this.controlDesc = "Enter additional activities to your resume";

      this.showAddControl({ selection: null, value: null, matchCount: 0 }, item);
    },
    addSectorExperience(item) {
      this._element = [];
      this._element.push({
        type: "boolean",
        display: false,
        Title: "Required"
      }); //Required
      this._element.push({ type: "string", display: true, Title: "Title" }); //Title
      this._element.push({ type: "yearsofexp", display: true, Title: "Years" }); //Years

      this.controlTitle = "Sector Experience";
      this.controlDesc = "Enter additional sector experience to your resume";

      if (item == undefined || item.length == 0) {
        //undefined is from create default resume, length 0 is from sync from sga
        var column = {
          required: false,
          title: "",
          years: ""
        };

        this.setting.profileConfiguration.personalInformation.education.sectorExperienceValue.experienceDetails = [];
        this.showAddControl(
          column,
          this.setting.profileConfiguration.personalInformation.education
            .sectorExperienceValue.experienceDetails
        );
      } else {
        this.showAddControl(item[0], item);
      }
    },
    addKnowledge(item) {
      this._element = [];
      this._element.push({
        type: "number",
        display: false,
        Title: "Match Count"
      }); //MatchCount
      this._element.push({
        type: "string",
        display: true,
        Title: "Description"
      }); //Selection
      this._element.push({ type: "string", display: false, Title: "Value" }); //Value
      this._element.push({
        type: "boolean",
        display: false,
        Title: "Verified"
      }); //Verified
      this._element.push({
        type: "yearsofexp",
        display: true,
        Title: "Years of Experience"
      }); //YearsOfExperience

      this.controlTitle = "Knowledge";
      this.controlDesc = "Enter additional knowledge to your resume";

      this.showAddControl({matchCount: 0,  selection: null, value: null, verified: null,  yearsOfExperience: null } , item);
    },
    addEssentialSkills(item) {
      this._element = [];
      this._element.push({
        type: "number",
        display: false,
        Title: "Match Count"
      }); //MatchCount
      this._element.push({
        type: "string",
        display: true,
        Title: "Description"
      }); //Selection
      this._element.push({ type: "string", display: false, Title: "Value" }); //Value

      this.controlTitle = "Essential Skill";
      this.controlDesc = "Enter additional essential skill to your resume";

      this.showAddControl({ selection: null, value: null, matchCount: 0 }, item);
    },
    addSkill(item) {
      this._element = [];
      this._element.push({
        type: "number",
        display: false,
        Title: "Match Count"
      }); //MatchCount
      this._element.push({
        type: "string",
        display: true,
        Title: "Description"
      }); //Selection
      this._element.push({ type: "string", display: false, Title: "Value" }); //Value
      this._element.push({
        type: "boolean",
        display: false,
        Title: "Verified"
      }); //Verified
      this._element.push({
        type: "yearsofexp",
        display: true,
        Title: "Years of Experience"
      }); //YearsOfExperience

      this.controlTitle = "Skill";
      this.controlDesc = "Enter additional skill to your resume";

      this.showAddControl({matchCount: 0,  selection: null, value: null, verified: null,  yearsOfExperience: null } , item);
    },
    addHiddenTalent(item) {
      this._element = [];
      this._element.push({
        type: "string",
        display: true,
        Title: "Description"
      }); //Description

      this.controlTitle = "Hidden Talent";
      this.controlDesc = "Enter additional talent to your resume";
      this.showAddControl(item[0], item);
    },
    addTechnologies(item) {
      this._element = [];
      this._element.push({
        type: "string",
        display: true,
        Title: "Description",
      });
      
      this._element.push({
        type: "yearsofexp",
        display: true,
        Title: "Years of Experience",
      });

      this.controlTitle = "Technology";
      this.controlDesc = "Enter additional technology to your resume";

      this.showAddControl({ selection: null, yearsOfExperience: null } , item);
    },
    handleCheckAllChange(value) {
      if (value) {
        this.$props.setting.profileConfiguration.personalInformation.education.secondaryLevel = true;
        this.$props.setting.profileConfiguration.personalInformation.education.thirdLevel = true;
        this.$props.setting.profileConfiguration.personalInformation.education.fourthLevel = true;
      } else {
        this.$props.setting.profileConfiguration.personalInformation.education.secondaryLevel = false;
        this.$props.setting.profileConfiguration.personalInformation.education.thirdLevel = false;
        this.$props.setting.profileConfiguration.personalInformation.education.fourthLevel = false;
      }
      this.isIndeterminate = false;
    },
    saveSettings(setting) {
      this.btnLoading = true;
      this.settingNameError = "";
      var hasError = false;

      var textboxes = $(".create_div .dot_textbox input:visible");
      //revert the border color
      textboxes.css("borderColor", "#DCDFE6");
      var theresError = false;
      $.each(textboxes, function(key, value) {
        debugger;
        if (
          value.value == "" &&
          !value.parentElement.classList.contains("nullable")
        ) {
          value.style.borderColor = "red";
          theresError = true;
        }
      });

      if (theresError) {
        this.$confirm(
          `<p style="text-align:center;padding-bottom:20px;">Some field(s) are blank. Please make sure to fill up all fields highlighted in red. </p>`,
          "Warning",
          {
            confirmButtonText: "OK",
            showCancelButton: false,
            closeOnClickModal: false,
            type: "warning",
            dangerouslyUseHTMLString: true,
            center: true
          }
        ).then(() => {
          this.btnLoading = false;
          return false;
        });
      } else {
        if (this.create) {
          setting.profileConfiguration.personalStatement = this.personalStatement;
        }

        if (setting.profileName == null || setting.profileName == "") {
          this.settingNameError = "Configuration Name is required.";
          hasError = true;
        } else {
          var set = this.settings.filter(
            s => s.profileName == setting.profileName
          );
          if (set.length != 0) {
            this.settingNameError = "Configuration name already exist.";
            hasError = true;
          } else {
            this.settingNameError = null;
          }
        }

        if (
          setting.profileConfiguration.personalStatement != null ||
          setting.profileConfiguration.personalStatement != undefined
        ) {
          var statement = setting.profileConfiguration.personalStatement.trim();
          if (statement.length >= 150) {
            hasError = true;
          }
        }

        //setting.ProfileConfiguration.CoreStrengthInformation.TaskDutiesValue.JobDescriptionTasks =

        if (!hasError) {
          if (this.isValid(setting)) {
            //revert the border color
            textboxes.css("borderColor", "#DCDFE6");
            this.$emit("save-setting", setting);
            this.btnLoading = false;
          } else {
            this.$confirm(
              `<p style="text-align:center;padding-bottom:20px;">You did not select any information to display on your public profile. Are you sure you want to save this configuration?</p>`,
              "Warning",
              {
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                type: "warning",
                dangerouslyUseHTMLString: true,
                center: true
              }
            ).then(() => {
              this.$emit("save-setting", setting);
              this.btnLoading = false;
            });
          }
        } else {
          this.btnLoading = false;
        }
      }
    },
    cancelSettings(setting) {
      this.$confirm(
        `<p style="text-align:center;padding-bottom:20px;">Do you want to cancel creating new configuration?</p>`,
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
          dangerouslyUseHTMLString: true,
          center: true
        }
      ).then(() => {
        this.clearFields();
        this.$emit("cancel-setting", setting);
      });
    },
    saveUpdateSetting(setting) {
      this.btnLoading = true;

      var textboxes = $(".el-collapse-item.is-active .dot_textbox input");
      //revert the border color
      textboxes.css("borderColor", "#DCDFE6");
      var theresError = false;
      $.each(textboxes, function(key, value) {
        if (
          value.value == "" &&
          !value.parentElement.classList.contains("nullable")
        ) {
          value.style.borderColor = "red";
          theresError = true;
        }
      });

      if (theresError) {
        this.$confirm(
          `<p style="text-align:center;padding-bottom:20px;">Some field(s) are blank. Please make sure to fill up all fields highlighted in red. </p>`,
          "Warning",
          {
            confirmButtonText: "OK",
            showCancelButton: false,
            closeOnClickModal: false,
            type: "warning",
            dangerouslyUseHTMLString: true,
            center: true
          }
        ).then(() => {
          this.btnLoading = false;
          return false;
        });
      } else {
        if (this.isValid(setting)) {
          this.$emit("save-update-setting", setting, false);
          this.btnLoading = false;
        } else {
          this.$confirm(
            `<p style="text-align:center;padding-bottom:20px;">You did not select any information to display on your public profile. Are you sure you want to save this configuration?</p>`,
            "Warning",
            {
              confirmButtonText: "Yes",
              cancelButtonText: "No",
              type: "warning",
              dangerouslyUseHTMLString: true,
              center: true
            }
          ).then(() => {
            //revert the border color
            textboxes.css("borderColor", "#DCDFE6");
            this.$emit("save-update-setting", setting, false);
            this.btnLoading = false;
          });
        }
      }
    },
    cancelUpdateSetting(setting) {
      this.cancelItem = setting;
      this.$confirm(
        `<p style="text-align:center;padding-bottom:20px;">Do you want to cancel your changes?</p>`,
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
          dangerouslyUseHTMLString: true,
          center: true
        }
      ).then(() => {
        this.cancelUpdate();
      });
    },
    cancelUpdate() {
      var setting = this.cancelItem;
      this.$emit("cancel-update-setting", setting);
      this.cancelItem = {};
    },
    removeSetting(setting) {
      this.$emit("remove-setting", setting);
    },
    chooseThisSetting(setting) {
      this.$emit("choose-setting", setting);
    },
    isValid(setting) {
      if (
        setting.profileConfiguration.personalInformation.email == false &&
        setting.profileConfiguration.personalInformation.address == false &&
        setting.profileConfiguration.personalInformation.phone == false &&
        setting.profileConfiguration.personalInformation.certifications ==
          false &&
        setting.profileConfiguration.personalInformation.education
          .secondaryLevel == false &&
        setting.profileConfiguration.personalInformation.education.thirdLevel ==
          false &&
        setting.profileConfiguration.personalInformation.education
          .fourthLevel == false &&
        setting.profileConfiguration.coreStrengthInformation.organizationName ==
          false &&
        setting.profileConfiguration.coreStrengthInformation.workHistory ==
          false &&
        setting.profileConfiguration.coreStrengthInformation.taskDuties ==
          false &&
        setting.profileConfiguration.coreStrengthInformation.activities ==
          false &&
        setting.profileConfiguration.coreStrengthInformation.sectorExperience ==
          false &&
        setting.profileConfiguration.coreStrengthInformation.knowledge ==
          false &&
        setting.profileConfiguration.coreStrengthInformation.essentialSkills ==
          false &&
        setting.profileConfiguration.coreStrengthInformation.skills == false &&
        setting.profileConfiguration.coreStrengthInformation.hiddenTalents ==
          false
      ) {
        return false;
      } else {
        return true;
      }
    },
    onCloseDialog(val) {
      this.cancelItem = {};
    },
    clearFields() {
      this.cancelItem = {};
      this.settingNameError = null;

      this.$props.setting.profileName = null;
      this.$props.setting.profileConfiguration.personalInformation.profilePhoto = false;
      this.$props.setting.profileConfiguration.personalInformation.email = false;
      this.$props.setting.profileConfiguration.personalInformation.address = false;
      this.$props.setting.profileConfiguration.personalInformation.phone = false;
      this.$props.setting.profileConfiguration.personalInformation.certifications = false;
      this.$props.setting.profileConfiguration.personalInformation.education.secondaryLevel = false;
      this.$props.setting.profileConfiguration.personalInformation.education.thirdLevel = false;
      this.$props.setting.profileConfiguration.personalInformation.education.fourthLevel = false;

      this.$props.setting.profileConfiguration.coreStrengthInformation.organizationName = false;
      this.setting.profileConfiguration.coreStrengthInformation.workHistory ==
        false;
      this.$props.setting.profileConfiguration.coreStrengthInformation.taskDuties = false;
      this.$props.setting.profileConfiguration.coreStrengthInformation.activities = false;
      this.$props.setting.profileConfiguration.coreStrengthInformation.sectorExperience = false;
      this.$props.setting.profileConfiguration.coreStrengthInformation.knowledge = false;
      this.$props.setting.profileConfiguration.coreStrengthInformation.essentialSkills = false;
      this.$props.setting.profileConfiguration.coreStrengthInformation.skills = false;
      this.$props.setting.profileConfiguration.coreStrengthInformation.hiddenTalents = false;
    },
    refresh(setting) {
      var obj = {
        requestId: this.currentUser.id,
        profileId: setting.id
      };

      this.$confirm(
        `<p style="text-align:center;padding-bottom:20px;">This process cannot be undone. Are you sure you want to sync this resume to your SGA profile?</p>`,
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCancelButton: true,
          type: "warning",
          dangerouslyUseHTMLString: true,
          center: true
        }
      ).then(() => {
        this.$store
          .dispatch("onlineprofile/updateresume", obj)
          .then(res => {
            this.$message.success("Resume Successfully Sync");
            setTimeout(() => {
              this.$emit("reload-setting");
            }, 500);
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },

    //
    openGradDateModal(val, graduationDate, isChecked) {
      if (isChecked) {
        if (graduationDate == "0001-01-01T00:00:00" || graduationDate == null)
          this.selectedGradDate = null;
        else this.selectedGradDate = graduationDate;

        this.optionToSetDate = val;
        this.showDateModal = true;
        this.isFromElementUI = false;
      }
    },
    setGraduationDate() {
      this.selectedGradDateError = null;

      if (this.selectedGradDate == null || this.selectedGradDate == "") {
        this.selectedGradDateError =
          "Estimated graduation date field is required.";
      } else if (this.selectedGradDate < new Date()) {
        this.selectedGradDateError =
          "Estimated graduation date must be a future date.";
      } else {
        if (this.isFromElementUI) {
          if (this.optionToSetDate == "HSD") {
            this.setting.profileConfiguration.personalInformation.education.secondaryLevelValue.highSchoolDiplomaGraduationDate = this.selectedGradDate;
          } else if (this.optionToSetDate == "GED") {
            this.setting.profileConfiguration.personalInformation.education.secondaryLevelValue.gedGraduationDate = this.selectedGradDate;
          } else if (
            this.optionToSetDate == "associatedegreedetails_template"
          ) {
            this.htmlElem.previousElementSibling.previousElementSibling.lastElementChild.innerText =
              "Currently attending, estimated graduation date is " +
              this.$moment(this.selectedGradDate).format("MMMM DD, YYYY");
            this.setting.profileConfiguration.personalInformation.education.thirdLevelValue.associateDegreeDetails[
              this.targetIndex
            ].graduationDate = this.selectedGradDate;
          } else if (
            this.optionToSetDate == "bachelorsdegreedetails_template"
          ) {
            this.htmlElem.previousElementSibling.previousElementSibling.lastElementChild.innerText =
              "Currently attending, estimated graduation date is " +
              this.$moment(this.selectedGradDate).format("MMMM DD, YYYY");
            this.setting.profileConfiguration.personalInformation.education.thirdLevelValue.bachelorsDegreeDetails[
              this.targetIndex
            ].graduationDate = this.selectedGradDate;
          } else if (this.optionToSetDate == "mastersdegreedetails_template") {
            this.htmlElem.previousElementSibling.previousElementSibling.lastElementChild.innerText =
              "Currently attending, estimated graduation date is " +
              this.$moment(this.selectedGradDate).format("MMMM DD, YYYY");
            this.setting.profileConfiguration.personalInformation.education.fourthLevelValue.mastersDegreeDetails[
              this.targetIndex
            ].graduationDate = this.selectedGradDate;
          } else if (this.optionToSetDate == "doctoraldegreedetails_template") {
            this.htmlElem.previousElementSibling.previousElementSibling.lastElementChild.innerText =
              "Currently attending, estimated graduation date is " +
              this.$moment(this.selectedGradDate).format("MMMM DD, YYYY");
            this.setting.profileConfiguration.personalInformation.education.fourthLevelValue.doctoralDegreeDetails[
              this.targetIndex
            ].graduationDate = this.selectedGradDate;
          }
        } else {
          if (this.optionToSetDate == "HSD") {
            this.setting.profileConfiguration.personalInformation.education.secondaryLevelValue.highSchoolDiplomaGraduationDate = this.selectedGradDate;
          } else if (this.optionToSetDate == "GED") {
            this.setting.profileConfiguration.personalInformation.education.secondaryLevelValue.gedGraduationDate = this.selectedGradDate;
          } else if (
            this.optionToSetDate == "associatedegreedetails_template"
          ) {
            this.htmlElem.previousElementSibling.innerHTML =
              "Currently attending, estimated graduation date is " +
              this.$moment(this.selectedGradDate).format("MMMM DD, YYYY");
            this.htmlElem.value = this.selectedGradDate;
          } else if (
            this.optionToSetDate == "bachelorsdegreedetails_template"
          ) {
            this.htmlElem.previousElementSibling.innerHTML =
              "Currently attending, estimated graduation date is " +
              this.$moment(this.selectedGradDate).format("MMMM DD, YYYY");
            this.htmlElem.value = this.selectedGradDate;
          } else if (this.optionToSetDate == "mastersdegreedetails_template") {
            this.htmlElem.previousElementSibling.innerHTML =
              "Currently attending, estimated graduation date is " +
              this.$moment(this.selectedGradDate).format("MMMM DD, YYYY");
            this.htmlElem.value = this.selectedGradDate;
          } else if (this.optionToSetDate == "doctoraldegreedetails_template") {
            this.htmlElem.previousElementSibling.innerHTML =
              "Currently attending, estimated graduation date is " +
              this.$moment(this.selectedGradDate).format("MMMM DD, YYYY");
            this.htmlElem.value = this.selectedGradDate;
          }
        }

        this.targetIndex = null;
        this.isFromElementUI = false;
        this.selectedGradDate = null;
        this.showDateModal = false;
      }
    },
    closeDateModal() {
      var isChecked = false;

      if (this.isFromElementUI) {
        if (this.optionToSetDate == "associatedegreedetails_template") {
          isChecked = this.htmlElem.previousElementSibling
            .previousElementSibling.firstElementChild.firstElementChild
            .nextElementSibling.checked;
          this.htmlElem.previousElementSibling.previousElementSibling.firstElementChild.firstElementChild.nextElementSibling.checked = !isChecked;
          this.htmlElem.previousElementSibling.previousElementSibling.classList.remove(
            "is-checked"
          );
          this.htmlElem.previousElementSibling.previousElementSibling.firstElementChild.classList.remove(
            "is-checked"
          );
          this.htmlElem.previousElementSibling.previousElementSibling.lastElementChild.innerText =
            "Please mark this checkbox if you are currently attending this program";
          this.htmlElem.previousElementSibling.previousElementSibling.nextElementSibling.nextElementSibling.value = null;
        } else if (this.optionToSetDate == "bachelorsdegreedetails_template") {
          isChecked = this.htmlElem.previousElementSibling
            .previousElementSibling.firstElementChild.firstElementChild
            .nextElementSibling.checked;
          this.htmlElem.previousElementSibling.previousElementSibling.firstElementChild.firstElementChild.nextElementSibling.checked = !isChecked;
          this.htmlElem.previousElementSibling.previousElementSibling.classList.remove(
            "is-checked"
          );
          this.htmlElem.previousElementSibling.previousElementSibling.firstElementChild.classList.remove(
            "is-checked"
          );
          this.htmlElem.previousElementSibling.previousElementSibling.lastElementChild.innerText =
            "Please mark this checkbox if you are currently attending this program";
          this.htmlElem.previousElementSibling.previousElementSibling.nextElementSibling.nextElementSibling.value = null;
        } else if (this.optionToSetDate == "mastersdegreedetails_template") {
          isChecked = this.htmlElem.previousElementSibling
            .previousElementSibling.firstElementChild.firstElementChild
            .nextElementSibling.checked;
          this.htmlElem.previousElementSibling.previousElementSibling.firstElementChild.firstElementChild.nextElementSibling.checked = !isChecked;
          this.htmlElem.previousElementSibling.previousElementSibling.classList.remove(
            "is-checked"
          );
          this.htmlElem.previousElementSibling.previousElementSibling.firstElementChild.classList.remove(
            "is-checked"
          );
          this.htmlElem.previousElementSibling.previousElementSibling.lastElementChild.innerText =
            "Please mark this checkbox if you are currently attending this program";
          this.htmlElem.previousElementSibling.previousElementSibling.nextElementSibling.nextElementSibling.value = null;
        } else if (this.optionToSetDate == "doctoraldegreedetails_template") {
          isChecked = this.htmlElem.previousElementSibling
            .previousElementSibling.firstElementChild.firstElementChild
            .nextElementSibling.checked;
          this.htmlElem.previousElementSibling.previousElementSibling.firstElementChild.firstElementChild.nextElementSibling.checked = !isChecked;
          this.htmlElem.previousElementSibling.previousElementSibling.classList.remove(
            "is-checked"
          );
          this.htmlElem.previousElementSibling.previousElementSibling.firstElementChild.classList.remove(
            "is-checked"
          );
          this.htmlElem.previousElementSibling.previousElementSibling.lastElementChild.innerText =
            "Please mark this checkbox if you are currently attending this program";
          this.htmlElem.previousElementSibling.previousElementSibling.nextElementSibling.nextElementSibling.value = null;
        }
      } else {
        if (this.optionToSetDate == "HSD") {
          this.setting.profileConfiguration.personalInformation.education.secondaryLevelValue.highSchoolDiplomaAttending = !this
            .setting.profileConfiguration.personalInformation.education
            .secondaryLevelValue.highSchoolDiplomaAttending;
        } else if (this.optionToSetDate == "GED") {
          this.setting.profileConfiguration.personalInformation.education.secondaryLevelValue.gedAttending = !this
            .setting.profileConfiguration.personalInformation.education
            .secondaryLevelValue.gedAttending;
        } else if (this.optionToSetDate == "associatedegreedetails_template") {
          this.htmlElem.previousElementSibling.previousElementSibling.checked = !this
            .htmlElem.previousElementSibling.previousElementSibling.checked;
        } else if (this.optionToSetDate == "bachelorsdegreedetails_template") {
          this.htmlElem.previousElementSibling.previousElementSibling.checked = !this
            .htmlElem.previousElementSibling.previousElementSibling.checked;
        } else if (this.optionToSetDate == "mastersdegreedetails_template") {
          this.htmlElem.previousElementSibling.previousElementSibling.checked = !this
            .htmlElem.previousElementSibling.previousElementSibling.checked;
        } else if (this.optionToSetDate == "doctoraldegreedetails_template") {
          this.htmlElem.previousElementSibling.previousElementSibling.checked = !this
            .htmlElem.previousElementSibling.previousElementSibling.checked;
        }
      }

      this.targetIndex = null;
      this.selectedGradDateError = null;
      this.selectedGradDate = null;
      this.optionToSetDate = null;
      this.isFromElementUI = false;
      this.showDateModal = false;
    },
    openAssocGradDateModal(val) {
      if (event.currentTarget.checked) {
        // Assign values
        this.optionToSetDate =
          event.currentTarget.parentElement.parentElement.parentElement.parentElement.id;
        this.htmlElem =
          event.currentTarget.parentElement.parentElement.nextElementSibling.nextElementSibling;

        this.targetIndex = val;
        this.isFromElementUI = true;
        this.showDateModal = true;
      } else {
        // Remove values
        event.currentTarget.parentElement.parentElement.lastElementChild.innerText =
          "Please mark this checkbox if you are currently attending this program";
        event.currentTarget.parentElement.parentElement.nextElementSibling.nextElementSibling.value = null;
      }
    },

    download() {
      const doc = new jsPDF();

      const favicon = document.getElementById("tsIcon").value;
      const step1 = document.getElementById("qrScan1").value;
      const step2 = document.getElementById("qrScan2").value;
      const step3 = document.getElementById("qrScan3").value;
      const cut = document.getElementById("cutHere").value;
      const board = document.getElementById("qrBoard").value;
      const rightL = document.getElementById("tslogo").value;
      const canvas = document
        .getElementById("qr-canvas-setting")
        .querySelector("canvas");
      const dataURL = canvas.toDataURL();

      const pageHeight =
        doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      const pageWidth =
        doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

      //doc.addImage(<image>, '<filetype>', <horizontal position>, <vertical position>, <image width>, <image height>);
      //doc.text(<string>, <horizontal position>, <vertical position>, <alignment>)

      // TalentSensus - Logo
      doc.addImage(favicon, "PNG", 125, 30, 50, 10);

      // How to Signup With No Email - Text Header
      // doc.setFont('Helvetica')
      doc.setFontType("bold");
      doc.setFontSize(14);
      doc.text(
        "How to View Online Profile via QRCode",
        pageWidth / 2,
        pageHeight - 245,
        "center"
      );

      // Aqua Green Line
      doc.setLineWidth(1.5);
      doc.setDrawColor(0, 200, 220);
      doc.line(100, 57, 108, 57);

      // Step 1 - Logo
      doc.addImage(step1, "PNG", 33, 65, 23, 23);

      // Step 1
      doc.setFont("Helvetica");
      doc.setFontType("normal");
      doc.setFontSize(11);
      doc.setTextColor(0, 0, 0);

      // Line 1
      doc.text(
        60,
        75,
        "Search your smart phone app store for a QR Code Scanner and"
      );
      doc.text(60, 80, "download a scanner app");

      // Line 2
      doc.text(
        60,
        90,
        "Open your smart phone camera or Scanner app and point the"
      );
      doc.text(60, 95, "camera at the QR code");

      // Step2 - Logo
      doc.addImage(step2, "PNG", 33, 95, 23, 23);

      // Line 3
      doc.text(60, 108, "Centre the QR code while your phone scans the code");

      // Line 4
      doc.text(60, 123, "Tap the link that appears after scanning the code");

      // Step3 - Logo
      doc.addImage(step3, "PNG", 33, 125, 23, 23);

      // Line 5
      doc.text(
        60,
        135,
        "You will find yourself on My TalentSensus Online Profile Page"
      );
      doc.text(60, 140, "with the information listed below.");

      // Cut Here - Logo
      doc.addImage(cut, "PNG", 30, 155, 147, 5);

      doc.addImage(board, "PNG", 20, 160, 180, 100);

      // Users resume details start's here
      // User's Image
      //doc.addImage(leftL, 'PNG', 35, 160, 30, 30);
      //doc.setFontSize(42)
      //doc.setTextColor(91, 192, 222)
      //doc.text(this.currentUser.Initials, pageWidth / 4.2, pageHeight - 117, 'center')

      // TalentSensus Logo
      //doc.addImage(rightL, 'PNG', 150, 160, 30, 30);
      doc.addImage(rightL, "PNG", 35, 170, 30, 30);

      // User's Fullname and style
      doc.setFontType("bold");
      doc.setFontSize(15);
      doc.setTextColor(35, 39, 42);
      doc.text(
        this.currentUser.fullName,
        pageWidth / 2.6,
        pageHeight - 115,
        "left"
      );

      // User's Role and style
      doc.setFontType("bold");
      doc.setFontSize(10);

      var roles = this.currentUser.roleTitle.split(",");
      var role1 = "";
      var topResumeTitle = 0;
      for (let index = 0; index < roles.length; index++) {
        if (index <= 1) {
          role1 += roles[index] + ",";
          if (index == roles.length - 1 || index == 1) {
            var formattedRole = role1
              .trim()
              .substring(0, role1.trim().length - 1);
            doc.text(formattedRole, pageWidth / 2.6, pageHeight - 110, "left");
            role1 = "";
            topResumeTitle = pageHeight - 110;
          }
        } else if (index <= 3) {
          role1 += roles[index] + ",";
          if (index == roles.length - 1 || index == 3) {
            var formattedRole = role1
              .trim()
              .substring(0, role1.trim().length - 1);
            doc.text(formattedRole, pageWidth / 2.6, pageHeight - 106, "left");
            role1 = "";
            topResumeTitle = pageHeight - 106;
          }
        } else {
          role1 += roles[index] + ",";
          if (index == roles.length - 1) {
            var formattedRole = role1
              .trim()
              .substring(0, role1.trim().length - 1);
            doc.text(formattedRole, pageWidth / 2.6, pageHeight - 102, "left");
            role1 = "";
            topResumeTitle = pageHeight - 102;
          }
        }
      }

      // User's Settings name and style
      doc.setFontType("normal");
      doc.setFontSize(9);
      var title =
        this.setting.profileName == "Default"
          ? "Default Resume"
          : this.setting.profileName;
      doc.text(
        "Resume : " + title,
        pageWidth / 2.6,
        topResumeTitle + 5,
        "left"
      );

      // Personal Information & Core Strenght Title
      doc.setFontType("bold");
      doc.setFontSize(12);
      doc.text("Personal", pageWidth / 4.5, pageHeight - 89, "center");
      doc.text("Information", pageWidth / 4.5, pageHeight - 85, "center");
      doc.text("Core Strength", pageWidth / 2.4, pageHeight - 89, "center");
      doc.text("Information", pageWidth / 2.4, pageHeight - 85, "center");

      doc.setFontType("normal");
      doc.setFontSize(9);
      const itemHeight = 4;
      // Personal items
      var personal = this.setting.profileConfiguration.personalInformation;
      var personalInfo = Object.entries(personal);
      var personalCtr = 0;
      for (let i = 0; i < personalInfo.length; i++) {
        if (i == 10) {
          const education = Object.entries(personalInfo[i][1]);
          if (education === undefined) {
            continue;
          }
          for (let j = 0; j < education.length; j++) {
            var res = education[j].includes(true);
            if (res) {
              personalCtr += 1;
              doc.text(
                personalInfo[i][0],
                pageWidth / 5.3,
                pageHeight - (83 - personalCtr * itemHeight),
                "left"
              );
              break;
            }
          }
        } else {
          var res = personalInfo[i].includes(true);
          if (res) {
            personalCtr += 1;
            if (i == 1) {
              doc.text(
                "ZipCode",
                pageWidth / 5.3,
                pageHeight - (83 - personalCtr * itemHeight),
                "left"
              );
            } else {
              doc.text(
                personalInfo[i][0],
                pageWidth / 5.3,
                pageHeight - (83 - personalCtr * itemHeight),
                "left"
              );
            }
          }
        }
      }

      // Core Strenght items
      var coreStrength = this.setting.profileConfiguration
        .coreStrengthInformation;
      var coreInfo = Object.entries(coreStrength);
      var coreCtr = 0;
      for (let i = 0; i < coreInfo.length; i++) {
        var res = coreInfo[i].includes(true);
        if (res) {
          coreCtr += 1;
          if (i == 0) {
            doc.text(
              this.$i18n.messages[localStorage.getItem("locale")]
                .uorganization + " Name",
              pageWidth / 2.8,
              pageHeight - (83 - coreCtr * itemHeight),
              "left"
            );
          } else {
            if (i < 6) {
              doc.text(
                coreInfo[i][0],
                pageWidth / 2.8,
                pageHeight - (83 - coreCtr * itemHeight),
                "left"
              );
            } else {
              doc.text(
                coreInfo[i][0],
                pageWidth / 2,
                pageHeight - (83 - (coreCtr - 6) * itemHeight),
                "left"
              );
            }
          }
        }
      }

      // QR Code
      doc.text(
        "Please scan my QR to view My Resume",
        pageWidth / 1.3,
        pageHeight - 89,
        "center"
      );
      //doc.text(this.createqrcodeLink, pageWidth / 2, pageHeight - 60, 'center')
      doc.addImage(dataURL, "PNG", 145, 210, 30, 30);

      // Date generated
      var today = new Date();
      var month = today.getMonth() + 1;
      var day = today.getDate();
      var year = today.getFullYear();

      doc.setFont("courier");
      doc.setFontType("normal");
      doc.setFontSize(10);
      doc.setTextColor(133, 133, 133);
      doc.text(
        day + "-" + month + "-" + year.toString().substring(2),
        pageWidth / 2,
        pageHeight - 15,
        "center"
      );

      // Contact us
      doc.text(
        "support@talentsensus.com",
        pageWidth / 2,
        pageHeight - 10,
        "center"
      );
      doc.save("qrcode.pdf");
    },
    toDataURLCustom(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    }
  }
};
</script>

<style scoped>
.setting-title {
  font-weight: bold;
  font-size: 16px;
}

.checkbox-child {
  padding-left: 10px;
}

.el-tooltip__popper {
  max-width: 500px !important;
  width: 400px !important;
}

@media screen and (max-width: 759px) {
  .dot_textbox .el-input {
    margin-left: unset !important;
  }

  .spacer {
    display: none;
  }

  .string-element,
  .number-element,
  .year-element,
  .grade-element,
  .date-element {
    width: 200px !important;
  }

  .boolean-element {
    width: 200px !important;
  }

  .mobile-label {
    height: 40px !important;
  }

  .mobile-element {
    height: 40px !important;
  }

  span {
    word-break: break-word;
  }

  span[data-label="Show Employer Address"],
  span[data-label="Show Employer Number"] {
    top: -10px !important;
    position: relative !important;
  }
}
</style>
